import React from "react";

export const fileUploadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="60"
    viewBox="0 0 56 60"
    fill="none"
  >
    <path
      d="M29.4646 0H5.05714C2.26416 0 0 2.26416 0 5.05714V54.9429C0 57.7358 2.26416 60 5.05714 60H39.1534C41.9464 60 44.2105 57.7358 44.2105 54.9429V14.8751C44.2105 13.5455 43.6869 12.2694 42.7529 11.323L33.0641 1.50496C32.1139 0.542041 30.8174 0 29.4646 0Z"
      fill="#E6E6E6"
    />
    <rect
      x="7.89453"
      y="25.2632"
      width="11.9668"
      height="4.73684"
      rx="1.68571"
      fill="white"
    />
    <rect
      x="7.89453"
      y="36.3159"
      width="11.9668"
      height="4.73684"
      rx="1.68571"
      fill="white"
    />
    <rect
      x="7.89453"
      y="47.3687"
      width="11.9668"
      height="4.73684"
      rx="1.68571"
      fill="white"
    />
    <rect
      x="24.3477"
      y="25.2632"
      width="11.9668"
      height="4.73684"
      rx="1.68571"
      fill="white"
    />
    <rect
      x="24.3477"
      y="36.3159"
      width="11.9668"
      height="4.73684"
      rx="1.68571"
      fill="white"
    />
    <rect
      x="24.3477"
      y="47.3687"
      width="11.9668"
      height="4.73684"
      rx="1.68571"
      fill="white"
    />
    <circle
      cx="44.2108"
      cy="48.9472"
      r="11.0526"
      fill="url(#paint0_linear_636_309409)"
    />
    <path
      d="M48.9486 49.5392H39.4749C39.1512 49.5392 38.8828 49.2708 38.8828 48.9471C38.8828 48.6234 39.1512 48.355 39.4749 48.355H48.9486C49.2723 48.355 49.5407 48.6234 49.5407 48.9471C49.5407 49.2708 49.2723 49.5392 48.9486 49.5392Z"
      fill="black"
    />
    <path
      d="M44.2112 54.2765C43.8876 54.2765 43.6191 54.0081 43.6191 53.6844V44.2108C43.6191 43.8871 43.8876 43.6187 44.2112 43.6187C44.5349 43.6187 44.8034 43.8871 44.8034 44.2108V53.6844C44.8034 54.0081 44.5349 54.2765 44.2112 54.2765Z"
      fill="black"
    />
    <defs>
      <linearGradient
        id="paint0_linear_636_309409"
        x1="55.2635"
        y1="48.9472"
        x2="33.1582"
        y2="48.9472"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#38DFE4" />
        <stop offset="1" stopColor="#01B0C3" />
      </linearGradient>
    </defs>
  </svg>
);
export const RoundedCheck = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <ellipse
        cx="14.1228"
        cy="14.125"
        rx="14.1228"
        ry="14.125"
        fill="#40C9A2"
      />
      <path
        d="M11.5727 19.9016C11.1707 19.9018 10.7851 19.7314 10.5011 19.4281L7.26144 15.9747C6.91285 15.6029 6.91285 15.0001 7.26144 14.6283C7.61015 14.2566 8.1754 14.2566 8.5241 14.6283L11.5727 17.8791L19.638 9.27879C19.9867 8.90707 20.5519 8.90707 20.9006 9.27879C21.2492 9.65063 21.2492 10.2534 20.9006 10.6252L12.6442 19.4281C12.3602 19.7314 11.9747 19.9018 11.5727 19.9016Z"
        fill="#212121"
      />
    </svg>
  );
};
export const CloseRoundedCheck = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <ellipse
        cx="14.1228"
        cy="14.125"
        rx="14.1228"
        ry="14.125"
        fill="#F95C59"
      />
      <path
        d="M10.708 19H9.266L13.116 14.002L9.406 9.326H10.806L13.802 13.148L16.784 9.326H18.184L14.488 14.002L18.324 19H16.882L13.802 14.954L10.708 19Z"
        fill="white"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.3833 12.877C7.76953 12.877 9.04785 12.4287 10.0938 11.6816L14.0283 15.6162C14.2109 15.7988 14.4517 15.8901 14.709 15.8901C15.2485 15.8901 15.6304 15.4751 15.6304 14.9438C15.6304 14.6948 15.5474 14.4541 15.3647 14.2798L11.4551 10.3618C12.2769 9.28271 12.7666 7.94629 12.7666 6.49365C12.7666 2.98242 9.89453 0.110352 6.3833 0.110352C2.88037 0.110352 0 2.97412 0 6.49365C0 10.0049 2.87207 12.877 6.3833 12.877ZM6.3833 11.499C3.64404 11.499 1.37793 9.23291 1.37793 6.49365C1.37793 3.75439 3.64404 1.48828 6.3833 1.48828C9.12256 1.48828 11.3887 3.75439 11.3887 6.49365C11.3887 9.23291 9.12256 11.499 6.3833 11.499Z"
        fill="#EBEBF5"
        fillOpacity="0.6"
      />
    </svg>
  );
};
export const LocationTarget = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25ZM12 5.25C8.28 5.25 5.25 8.28 5.25 12C5.25 15.72 8.28 18.75 12 18.75C15.72 18.75 18.75 15.72 18.75 12C18.75 8.28 15.72 5.25 12 5.25Z"
        fill="url(#paint0_linear_205_36348)"
      />
      <path
        d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75Z"
        fill="url(#paint1_linear_205_36348)"
      />
      <path
        d="M12 4.75C11.59 4.75 11.25 4.41 11.25 4V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V4C12.75 4.41 12.41 4.75 12 4.75Z"
        fill="url(#paint2_linear_205_36348)"
      />
      <path
        d="M4 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H4C4.41 11.25 4.75 11.59 4.75 12C4.75 12.41 4.41 12.75 4 12.75Z"
        fill="url(#paint3_linear_205_36348)"
      />
      <path
        d="M12 22.75C11.59 22.75 11.25 22.41 11.25 22V20C11.25 19.59 11.59 19.25 12 19.25C12.41 19.25 12.75 19.59 12.75 20V22C12.75 22.41 12.41 22.75 12 22.75Z"
        fill="url(#paint4_linear_205_36348)"
      />
      <path
        d="M22 12.75H20C19.59 12.75 19.25 12.41 19.25 12C19.25 11.59 19.59 11.25 20 11.25H22C22.41 11.25 22.75 11.59 22.75 12C22.75 12.41 22.41 12.75 22 12.75Z"
        fill="url(#paint5_linear_205_36348)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_205_36348"
          x1="12"
          y1="3.75"
          x2="12"
          y2="20.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5B640" />
          <stop offset="0.494792" stopColor="#E59B0C" />
          <stop offset="1" stopColor="#E26528" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_205_36348"
          x1="12"
          y1="8.25"
          x2="12"
          y2="15.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5B640" />
          <stop offset="0.494792" stopColor="#E59B0C" />
          <stop offset="1" stopColor="#E26528" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_205_36348"
          x1="12"
          y1="1.25"
          x2="12"
          y2="4.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5B640" />
          <stop offset="0.494792" stopColor="#E59B0C" />
          <stop offset="1" stopColor="#E26528" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_205_36348"
          x1="3"
          y1="11.25"
          x2="3"
          y2="12.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5B640" />
          <stop offset="0.494792" stopColor="#E59B0C" />
          <stop offset="1" stopColor="#E26528" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_205_36348"
          x1="12"
          y1="19.25"
          x2="12"
          y2="22.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5B640" />
          <stop offset="0.494792" stopColor="#E59B0C" />
          <stop offset="1" stopColor="#E26528" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_205_36348"
          x1="21"
          y1="11.25"
          x2="21"
          y2="12.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5B640" />
          <stop offset="0.494792" stopColor="#E59B0C" />
          <stop offset="1" stopColor="#E26528" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LocationIconGradient = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.318 16.4167L11.8262 16.0311L12.318 16.4167ZM7.68332 16.4167L7.19151 16.8024L7.68332 16.4167ZM10.0007 18.3376V17.7126V18.3376ZM16.0423 8.00692C16.0423 9.029 15.5093 10.3966 14.6704 11.8797C13.8454 13.3383 12.7792 14.8158 11.8262 16.0311L12.8098 16.8024C13.7816 15.5632 14.89 14.0305 15.7585 12.4951C16.6131 10.9842 17.2923 9.37419 17.2923 8.00692H16.0423ZM8.17514 16.0311C7.22214 14.8158 6.15589 13.3383 5.33086 11.8797C4.492 10.3966 3.95898 9.029 3.95898 8.00692H2.70898C2.70898 9.37419 3.38824 10.9842 4.24285 12.4951C5.1113 14.0305 6.21972 15.5632 7.19151 16.8024L8.17514 16.0311ZM3.95898 8.00692C3.95898 4.3461 6.7063 1.45801 10.0007 1.45801V0.208008C5.9312 0.208008 2.70898 3.74365 2.70898 8.00692H3.95898ZM10.0007 1.45801C13.295 1.45801 16.0423 4.3461 16.0423 8.00692H17.2923C17.2923 3.74365 14.0701 0.208008 10.0007 0.208008V1.45801ZM11.8262 16.0311C11.3104 16.6888 10.9708 17.1185 10.6666 17.3947C10.3893 17.6467 10.2041 17.7126 10.0007 17.7126V18.9626C10.6082 18.9626 11.0796 18.7083 11.5071 18.32C11.9079 17.956 12.3214 17.4252 12.8098 16.8024L11.8262 16.0311ZM7.19151 16.8024C7.67991 17.4252 8.09345 17.956 8.49419 18.32C8.92168 18.7083 9.3931 18.9626 10.0007 18.9626V17.7126C9.79717 17.7126 9.61203 17.6467 9.33467 17.3947C9.03055 17.1185 8.69094 16.6888 8.17514 16.0311L7.19151 16.8024ZM6.87565 8.33301C6.87565 10.0589 8.27476 11.458 10.0007 11.458V10.208C8.96512 10.208 8.12565 9.36854 8.12565 8.33301H6.87565ZM10.0007 11.458C11.7265 11.458 13.1257 10.0589 13.1257 8.33301H11.8757C11.8757 9.36854 11.0362 10.208 10.0007 10.208V11.458ZM13.1257 8.33301C13.1257 6.60712 11.7265 5.20801 10.0007 5.20801V6.45801C11.0362 6.45801 11.8757 7.29747 11.8757 8.33301H13.1257ZM10.0007 5.20801C8.27476 5.20801 6.87565 6.60712 6.87565 8.33301H8.12565C8.12565 7.29747 8.96512 6.45801 10.0007 6.45801V5.20801Z"
        fill="url(#paint0_linear_205_36370)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_205_36370"
          x1="15.834"
          y1="7.39722"
          x2="3.78559"
          y2="10.0193"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E26429" />
          <stop offset="0.51875" stopColor="#E7B300" />
          <stop offset="1" stopColor="#F7B748" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CheckCircleGradient = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        stoprule="evenodd"
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.5588 7.50027C15.8351 7.19167 15.8089 6.71752 15.5003 6.44123C15.1917 6.16493 14.7175 6.19113 14.4412 6.49973L11.0721 10.2629C10.3894 11.0254 9.9296 11.5363 9.53652 11.8667C9.16207 12.1814 8.94213 12.25 8.75 12.25C8.55787 12.25 8.33794 12.1814 7.96348 11.8667C7.5704 11.5363 7.11064 11.0254 6.42794 10.2629L5.55877 9.29209C5.28248 8.98349 4.80833 8.9573 4.49973 9.23359C4.19113 9.50988 4.16493 9.98403 4.44123 10.2926L5.34753 11.3049C5.98338 12.0152 6.51374 12.6076 6.99835 13.0149C7.51099 13.4458 8.06393 13.75 8.75 13.75C9.43607 13.75 9.98901 13.4458 10.5016 13.0149C10.9863 12.6076 11.5166 12.0152 12.1525 11.3049L15.5588 7.50027Z"
        fill="url(#paint0_linear_1651_560)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1651_560"
          x1="18.75"
          y1="7.5"
          x2="1.25"
          y2="12.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E26429" />
          <stop offset="0.51875" stopColor="#E7B300" />
          <stop offset="1" stopColor="#F7B748" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const CameraIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 9.8541C3 8.83011 3.83011 8 4.8541 8V8C5.55638 8 6.19839 7.60322 6.51246 6.97508L7.44721 5.10557C7.71617 4.56766 7.85065 4.2987 8.0923 4.14935C8.33395 4 8.63466 4 9.23607 4H14.7639C15.3653 4 15.666 4 15.9077 4.14935C16.1493 4.2987 16.2838 4.56766 16.5528 5.10557L17.4875 6.97508C17.8016 7.60322 18.4436 8 19.1459 8V8C20.1699 8 21 8.83011 21 9.8541V17C21 18.4142 21 19.1213 20.5607 19.5607C20.1213 20 19.4142 20 18 20H6C4.58579 20 3.87868 20 3.43934 19.5607C3 19.1213 3 18.4142 3 17V9.8541Z"
        stroke="#797979"
        strokeWidth="1.5"
      />
      <circle cx="12" cy="13" r="3.25" stroke="#797979" strokeWidth="1.5" />
    </svg>
  );
};

export const ArrowDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
    >
      <path
        d="M11.5327 1.52796C11.8243 1.23376 11.8222 0.758893 11.528 0.467309C11.2338 0.175726 10.7589 0.177844 10.4673 0.472041L8.72 2.23501C8.01086 2.9505 7.52282 3.44131 7.1093 3.77341C6.7076 4.096 6.44958 4.20668 6.2185 4.23613C6.07341 4.25462 5.92659 4.25462 5.7815 4.23613C5.55042 4.20668 5.2924 4.09601 4.89071 3.77341C4.47718 3.44131 3.98914 2.95051 3.28 2.23501L1.53269 0.472042C1.24111 0.177845 0.766238 0.175726 0.472041 0.46731C0.177844 0.758894 0.175726 1.23376 0.467309 1.52796L2.24609 3.32269C2.91604 3.99866 3.46359 4.55114 3.95146 4.94294C4.45879 5.35037 4.97373 5.64531 5.59184 5.72409C5.86287 5.75864 6.13714 5.75864 6.40816 5.72409C7.02628 5.64531 7.54122 5.35037 8.04854 4.94294C8.53641 4.55114 9.08396 3.99867 9.7539 3.32269L11.5327 1.52796Z"
        fill="#929399"
      />
    </svg>
  );
};

export const ArrowRoundedLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
    >
      <path
        d="M1.52796 0.467309C1.23376 0.175726 0.758893 0.177844 0.467309 0.472041C0.175726 0.766238 0.177844 1.24111 0.472041 1.53269L2.23501 3.28C2.9505 3.98914 3.44131 4.47718 3.77341 4.8907C4.09601 5.2924 4.20668 5.55042 4.23613 5.7815C4.25462 5.92659 4.25462 6.07341 4.23613 6.2185C4.20668 6.44958 4.09601 6.7076 3.77341 7.10929C3.44131 7.52282 2.95051 8.01086 2.23501 8.72L0.472042 10.4673C0.177845 10.7589 0.175726 11.2338 0.46731 11.528C0.758894 11.8222 1.23376 11.8243 1.52796 11.5327L3.32269 9.75391C3.99866 9.08396 4.55114 8.53641 4.94294 8.04854C5.35037 7.54121 5.64531 7.02627 5.72409 6.40816C5.75864 6.13713 5.75864 5.86286 5.72409 5.59184C5.64531 4.97372 5.35037 4.45878 4.94294 3.95146C4.55114 3.46359 3.99867 2.91604 3.32269 2.2461L1.52796 0.467309Z"
        fill="#929399"
      />
    </svg>
  );
};

export const ArrowTriangleDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="5"
      viewBox="0 0 11 5"
      fill="none"
    >
      <path
        d="M9.33011 0.0284424L5.29931 0.0284424L1.66964 0.0284424C1.04852 0.0284424 0.737966 0.778961 1.17792 1.21892L4.52938 4.57037C5.06639 5.10738 5.93984 5.10738 6.47685 4.57037L7.75143 3.29579L9.8283 1.21892C10.2618 0.778961 9.95123 0.0284424 9.33011 0.0284424Z"
        fill="#898989"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
    >
      <path
        d="M3.05081 0C1.50993 0 0.23584 1.21705 0.23584 2.74871C0.23584 3.52432 0.571099 4.26072 1.15403 4.77978L3.32242 6.71058C3.9066 7.23074 4.23584 7.96167 4.23584 8.72401V11.5089C4.23584 12.7497 5.65949 13.4114 6.64181 12.7174L7.93599 11.8031C8.53993 11.3765 8.90251 10.6904 8.90251 9.9545V8.80138C8.90251 8.00149 9.26492 7.23801 9.90019 6.71587L12.2471 4.78688C12.8717 4.27352 13.2358 3.51521 13.2358 2.712C13.2358 1.20062 11.9787 0 10.4587 0H3.05081Z"
        fill="#929399"
      />
    </svg>
  );
};

export const FilterDropdownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        stoprule="evenodd"
        d="M4.47246 0.25C2.14046 0.25 0.25 2.14046 0.25 4.47246C0.25 5.65604 0.746758 6.78529 1.61924 7.58506L4.87183 10.5666C5.75 11.3716 6.25 12.5082 6.25 13.6995V18C6.25 19.8615 8.36186 20.9369 9.86734 19.842L11.8086 18.4302C12.7142 17.7716 13.25 16.7194 13.25 15.5996V13.819C13.25 12.5689 13.8004 11.3821 14.7547 10.5746L18.2751 7.59586C19.2105 6.80435 19.75 5.64113 19.75 4.41577C19.75 2.11508 17.8849 0.25 15.5842 0.25H4.47246ZM1.75 4.47246C1.75 2.96889 2.96889 1.75 4.47246 1.75H15.5842C17.0565 1.75 18.25 2.94351 18.25 4.41577C18.25 5.19991 17.9048 5.94427 17.3062 6.45078L13.7858 9.42952C12.4947 10.522 11.75 12.1276 11.75 13.819V15.5996C11.75 16.2395 11.4438 16.8407 10.9263 17.2171L8.98508 18.6289C8.47106 19.0028 7.75 18.6356 7.75 18V13.6995C7.75 12.0877 7.07353 10.55 5.88542 9.46087L2.63283 6.47933C2.07029 5.96367 1.75 5.23558 1.75 4.47246Z"
        fill="white"
      />
    </svg>
  );
};

export const FilterDropdownDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.7354 10.6265C19.0904 10.2521 19.0878 9.64768 18.7297 9.27658C18.3715 8.90547 17.7934 8.90817 17.4385 9.2826L15.3113 11.5264C14.448 12.437 13.8539 13.0617 13.3504 13.4843C12.8614 13.8949 12.5473 14.0358 12.266 14.0733C12.0894 14.0968 11.9106 14.0968 11.734 14.0733C11.4527 14.0358 11.1386 13.8949 10.6496 13.4843C10.1461 13.0617 9.55199 12.437 8.6887 11.5264L6.56154 9.2826C6.20657 8.90817 5.62846 8.90547 5.27031 9.27658C4.91216 9.64768 4.90958 10.2521 5.26455 10.6265L7.43003 12.9107C8.24561 13.771 8.91219 14.4742 9.50612 14.9728C10.1237 15.4914 10.7506 15.8668 11.5031 15.967C11.8331 16.011 12.1669 16.011 12.4969 15.967C13.2494 15.8668 13.8763 15.4914 14.4939 14.9728C15.0878 14.4742 15.7544 13.771 16.57 12.9107L18.7354 10.6265Z"
        fill="white"
      />
    </svg>
  );
};

export const SliderIcon1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
    >
      <circle cx="5.52466" cy="5.80567" r="5.00001" fill="#797979" />
    </svg>
  );
};

export const SliderIcon2 = () => {
  return (
    <svg
      width="26"
      height="11"
      viewBox="0 0 26 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.0246582"
        y="0.805664"
        width="25"
        height="10"
        rx="5.00001"
        fill="#E7B300"
      />
    </svg>
  );
};

export const ProfileBlueTick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M6.69126 2.29131C7.68116 1.40679 9.17748 1.40679 10.1674 2.29131C10.608 2.68498 11.1691 2.91742 11.759 2.95059C13.0844 3.02511 14.1425 4.08316 14.217 5.40858C14.2502 5.99848 14.4826 6.55965 14.8763 7.00022C15.7608 7.99012 15.7608 9.48644 14.8763 10.4763C14.4826 10.9169 14.2502 11.4781 14.217 12.068C14.1425 13.3934 13.0844 14.4515 11.759 14.526C11.1691 14.5591 10.608 14.7916 10.1674 15.1853C9.17748 16.0698 7.68116 16.0698 6.69126 15.1853C6.25069 14.7916 5.68952 14.5591 5.09962 14.526C3.7742 14.4515 2.71615 13.3934 2.64163 12.068C2.60846 11.4781 2.37602 10.9169 1.98235 10.4763C1.09783 9.48644 1.09783 7.99012 1.98235 7.00022C2.37602 6.55965 2.60846 5.99848 2.64163 5.40858C2.71615 4.08316 3.7742 3.02511 5.09962 2.95059C5.68952 2.91742 6.25069 2.68498 6.69126 2.29131Z"
        fill="#3F87E1"
      />
      <path
        d="M5.22927 8.73838L6.39038 9.89949C6.96967 10.4788 7.25931 10.7684 7.61177 10.7524C7.96422 10.7364 8.22645 10.4218 8.75091 9.79241L11.6293 6.33838"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const LocationArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.40018 6.32015L15.8902 3.49015C19.7002 2.22015 21.7702 4.30015 20.5102 8.11015L17.6802 16.6002C15.7802 22.3102 12.6602 22.3102 10.7602 16.6002L9.92018 14.0802L7.40018 13.2402C1.69018 11.3402 1.69018 8.23015 7.40018 6.32015Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1099 13.6501L13.6899 10.0601"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GlobeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle cx="7" cy="7" r="6" stroke="#AFAFAF" strokeWidth="0.75" />
      <path
        d="M11.929 3.40478C11.3862 4.04014 10.6651 4.56146 9.82538 4.92567C8.98562 5.28987 8.05126 5.48651 7.09949 5.49933C6.14771 5.51215 5.20584 5.3408 4.35168 4.99942C3.49751 4.65804 2.75558 4.15643 2.18716 3.53604"
        stroke="#AFAFAF"
        strokeWidth="0.75"
      />
      <path
        d="M11.929 10.5952C11.3862 9.95986 10.6651 9.43854 9.82538 9.07433C8.98562 8.71013 8.05126 8.51349 7.09949 8.50067C6.14771 8.48785 5.20584 8.6592 4.35168 9.00058C3.49751 9.34196 2.75558 9.84357 2.18716 10.464"
        stroke="#AFAFAF"
        strokeWidth="0.75"
      />
      <path d="M7 1V13" stroke="#AFAFAF" strokeWidth="0.75" />
    </svg>
  );
};

export const GlobeIconBg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill="white"
      />
      <path
        d="M9.00023 21.75H8.00023C7.59023 21.75 7.25023 21.41 7.25023 21C7.25023 20.59 7.57023 20.26 7.98023 20.25C6.41023 14.89 6.41023 9.11 7.98023 3.75C7.57023 3.74 7.25023 3.41 7.25023 3C7.25023 2.59 7.59023 2.25 8.00023 2.25H9.00023C9.24023 2.25 9.47023 2.37 9.61023 2.56C9.75023 2.76 9.79023 3.01 9.71023 3.24C7.83023 8.89 7.83023 15.11 9.71023 20.77C9.79023 21 9.75023 21.25 9.61023 21.45C9.47023 21.63 9.24023 21.75 9.00023 21.75Z"
        fill="white"
      />
      <path
        d="M15.0004 21.7502C14.9204 21.7502 14.8404 21.7402 14.7604 21.7102C14.3704 21.5802 14.1504 21.1502 14.2904 20.7602C16.1704 15.1102 16.1704 8.89018 14.2904 3.23018C14.1604 2.84018 14.3704 2.41018 14.7604 2.28018C15.1604 2.15018 15.5804 2.36018 15.7104 2.75018C17.7004 8.71018 17.7004 15.2702 15.7104 21.2202C15.6104 21.5502 15.3104 21.7502 15.0004 21.7502Z"
        fill="white"
      />
      <path
        d="M12 17.1998C9.21 17.1998 6.43 16.8098 3.75 16.0198C3.74 16.4198 3.41 16.7498 3 16.7498C2.59 16.7498 2.25 16.4098 2.25 15.9998V14.9998C2.25 14.7598 2.37 14.5298 2.56 14.3898C2.76 14.2498 3.01 14.2098 3.24 14.2898C8.89 16.1698 15.12 16.1698 20.77 14.2898C21 14.2098 21.25 14.2498 21.45 14.3898C21.65 14.5298 21.76 14.7598 21.76 14.9998V15.9998C21.76 16.4098 21.42 16.7498 21.01 16.7498C20.6 16.7498 20.27 16.4298 20.26 16.0198C17.57 16.8098 14.79 17.1998 12 17.1998Z"
        fill="white"
      />
      <path
        d="M20.9998 9.74986C20.9198 9.74986 20.8398 9.73986 20.7598 9.70986C15.1098 7.82986 8.87978 7.82986 3.22978 9.70986C2.82978 9.83986 2.40978 9.62986 2.27978 9.23986C2.15978 8.83986 2.36978 8.41986 2.75978 8.28986C8.71978 6.29986 15.2798 6.29986 21.2298 8.28986C21.6198 8.41986 21.8398 8.84986 21.6998 9.23986C21.6098 9.54986 21.3098 9.74986 20.9998 9.74986Z"
        fill="white"
      />
    </svg>
  );
};

export const LockIconBg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 10.75C17.59 10.75 17.25 10.41 17.25 10V8C17.25 4.85 16.36 2.75 12 2.75C7.64 2.75 6.75 4.85 6.75 8V10C6.75 10.41 6.41 10.75 6 10.75C5.59 10.75 5.25 10.41 5.25 10V8C5.25 5.1 5.95 1.25 12 1.25C18.05 1.25 18.75 5.1 18.75 8V10C18.75 10.41 18.41 10.75 18 10.75Z"
        fill="white"
      />
      <path
        d="M12 19.25C10.21 19.25 8.75 17.79 8.75 16C8.75 14.21 10.21 12.75 12 12.75C13.79 12.75 15.25 14.21 15.25 16C15.25 17.79 13.79 19.25 12 19.25ZM12 14.25C11.04 14.25 10.25 15.04 10.25 16C10.25 16.96 11.04 17.75 12 17.75C12.96 17.75 13.75 16.96 13.75 16C13.75 15.04 12.96 14.25 12 14.25Z"
        fill="white"
      />
      <path
        d="M17 22.75H7C2.59 22.75 1.25 21.41 1.25 17V15C1.25 10.59 2.59 9.25 7 9.25H17C21.41 9.25 22.75 10.59 22.75 15V17C22.75 21.41 21.41 22.75 17 22.75ZM7 10.75C3.42 10.75 2.75 11.43 2.75 15V17C2.75 20.57 3.42 21.25 7 21.25H17C20.58 21.25 21.25 20.57 21.25 17V15C21.25 11.43 20.58 10.75 17 10.75H7Z"
        fill="white"
      />
    </svg>
  );
};

export const UserIconBg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.16055 11.62C9.13055 11.62 9.11055 11.62 9.08055 11.62C9.03055 11.61 8.96055 11.61 8.90055 11.62C6.00055 11.53 3.81055 9.25 3.81055 6.44C3.81055 3.58 6.14055 1.25 9.00055 1.25C11.8605 1.25 14.1905 3.58 14.1905 6.44C14.1805 9.25 11.9805 11.53 9.19055 11.62C9.18055 11.62 9.17055 11.62 9.16055 11.62ZM9.00055 2.75C6.97055 2.75 5.31055 4.41 5.31055 6.44C5.31055 8.44 6.87055 10.05 8.86055 10.12C8.92055 10.11 9.05055 10.11 9.18055 10.12C11.1405 10.03 12.6805 8.42 12.6905 6.44C12.6905 4.41 11.0305 2.75 9.00055 2.75Z"
        fill="white"
      />
      <path
        d="M16.5404 11.75C16.5104 11.75 16.4804 11.75 16.4504 11.74C16.0404 11.78 15.6204 11.49 15.5804 11.08C15.5404 10.67 15.7904 10.3 16.2004 10.25C16.3204 10.24 16.4504 10.24 16.5604 10.24C18.0204 10.16 19.1604 8.96 19.1604 7.49C19.1604 5.97 17.9304 4.74 16.4104 4.74C16.0004 4.75 15.6604 4.41 15.6604 4C15.6604 3.59 16.0004 3.25 16.4104 3.25C18.7504 3.25 20.6604 5.16 20.6604 7.5C20.6604 9.8 18.8604 11.66 16.5704 11.75C16.5604 11.75 16.5504 11.75 16.5404 11.75Z"
        fill="white"
      />
      <path
        d="M9.16961 22.55C7.20961 22.55 5.23961 22.05 3.74961 21.05C2.35961 20.13 1.59961 18.87 1.59961 17.5C1.59961 16.13 2.35961 14.86 3.74961 13.93C6.74961 11.94 11.6096 11.94 14.5896 13.93C15.9696 14.85 16.7396 16.11 16.7396 17.48C16.7396 18.85 15.9796 20.12 14.5896 21.05C13.0896 22.05 11.1296 22.55 9.16961 22.55ZM4.57961 15.19C3.61961 15.83 3.09961 16.65 3.09961 17.51C3.09961 18.36 3.62961 19.18 4.57961 19.81C7.06961 21.48 11.2696 21.48 13.7596 19.81C14.7196 19.17 15.2396 18.35 15.2396 17.49C15.2396 16.64 14.7096 15.82 13.7596 15.19C11.2696 13.53 7.06961 13.53 4.57961 15.19Z"
        fill="white"
      />
      <path
        d="M18.3402 20.75C17.9902 20.75 17.6802 20.51 17.6102 20.15C17.5302 19.74 17.7902 19.35 18.1902 19.26C18.8202 19.13 19.4002 18.88 19.8502 18.53C20.4202 18.1 20.7302 17.56 20.7302 16.99C20.7302 16.42 20.4202 15.88 19.8602 15.46C19.4202 15.12 18.8702 14.88 18.2202 14.73C17.8202 14.64 17.5602 14.24 17.6502 13.83C17.7402 13.43 18.1402 13.17 18.5502 13.26C19.4102 13.45 20.1602 13.79 20.7702 14.26C21.7002 14.96 22.2302 15.95 22.2302 16.99C22.2302 18.03 21.6902 19.02 20.7602 19.73C20.1402 20.21 19.3602 20.56 18.5002 20.73C18.4402 20.75 18.3902 20.75 18.3402 20.75Z"
        fill="white"
      />
    </svg>
  );
};

export const BellIconPost = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0199 20.5299C9.68987 20.5299 7.35987 20.1599 5.14987 19.4199C4.30987 19.1299 3.66987 18.5399 3.38987 17.7699C3.09987 16.9999 3.19987 16.1499 3.65987 15.3899L4.80987 13.4799C5.04987 13.0799 5.26987 12.2799 5.26987 11.8099V8.91992C5.26987 5.19992 8.29987 2.16992 12.0199 2.16992C15.7399 2.16992 18.7699 5.19992 18.7699 8.91992V11.8099C18.7699 12.2699 18.9899 13.0799 19.2299 13.4899L20.3699 15.3899C20.7999 16.1099 20.8799 16.9799 20.5899 17.7699C20.2999 18.5599 19.6699 19.1599 18.8799 19.4199C16.6799 20.1599 14.3499 20.5299 12.0199 20.5299ZM12.0199 3.66992C9.12987 3.66992 6.76987 6.01992 6.76987 8.91992V11.8099C6.76987 12.5399 6.46987 13.6199 6.09987 14.2499L4.94987 16.1599C4.72987 16.5299 4.66987 16.9199 4.79987 17.2499C4.91987 17.5899 5.21987 17.8499 5.62987 17.9899C9.80987 19.3899 14.2399 19.3899 18.4199 17.9899C18.7799 17.8699 19.0599 17.5999 19.1899 17.2399C19.3199 16.8799 19.2899 16.4899 19.0899 16.1599L17.9399 14.2499C17.5599 13.5999 17.2699 12.5299 17.2699 11.7999V8.91992C17.2699 6.01992 14.9199 3.66992 12.0199 3.66992Z"
        fill="white"
      />
      <path
        d="M13.8806 3.93969C13.8106 3.93969 13.7406 3.92969 13.6706 3.90969C13.3806 3.82969 13.1006 3.76969 12.8306 3.72969C11.9806 3.61969 11.1606 3.67969 10.3906 3.90969C10.1106 3.99969 9.8106 3.90969 9.6206 3.69969C9.4306 3.48969 9.3706 3.18969 9.4806 2.91969C9.8906 1.86969 10.8906 1.17969 12.0306 1.17969C13.1706 1.17969 14.1706 1.85969 14.5806 2.91969C14.6806 3.18969 14.6306 3.48969 14.4406 3.69969C14.2906 3.85969 14.0806 3.93969 13.8806 3.93969Z"
        fill="white"
      />
      <path
        d="M12.0195 22.8096C11.0295 22.8096 10.0695 22.4096 9.36953 21.7096C8.66953 21.0096 8.26953 20.0496 8.26953 19.0596H9.76953C9.76953 19.6496 10.0095 20.2296 10.4295 20.6496C10.8495 21.0696 11.4295 21.3096 12.0195 21.3096C13.2595 21.3096 14.2695 20.2996 14.2695 19.0596H15.7695C15.7695 21.1296 14.0895 22.8096 12.0195 22.8096Z"
        fill="white"
      />
    </svg>
  );
};

export const GroupIconPost = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.25C9.37665 1.25 7.25 3.37665 7.25 6C7.25 8.62335 9.37665 10.75 12 10.75C14.6234 10.75 16.75 8.62335 16.75 6C16.75 3.37665 14.6234 1.25 12 1.25ZM8.75 6C8.75 4.20507 10.2051 2.75 12 2.75C13.7949 2.75 15.25 4.20507 15.25 6C15.25 7.79493 13.7949 9.25 12 9.25C10.2051 9.25 8.75 7.79493 8.75 6Z"
        fill="white"
      />
      <path
        d="M18 3.25C17.5858 3.25 17.25 3.58579 17.25 4C17.25 4.41421 17.5858 4.75 18 4.75C19.3765 4.75 20.25 5.65573 20.25 6.5C20.25 7.34427 19.3765 8.25 18 8.25C17.5858 8.25 17.25 8.58579 17.25 9C17.25 9.41421 17.5858 9.75 18 9.75C19.9372 9.75 21.75 8.41715 21.75 6.5C21.75 4.58285 19.9372 3.25 18 3.25Z"
        fill="white"
      />
      <path
        d="M6.75 4C6.75 3.58579 6.41421 3.25 6 3.25C4.06278 3.25 2.25 4.58285 2.25 6.5C2.25 8.41715 4.06278 9.75 6 9.75C6.41421 9.75 6.75 9.41421 6.75 9C6.75 8.58579 6.41421 8.25 6 8.25C4.62351 8.25 3.75 7.34427 3.75 6.5C3.75 5.65573 4.62351 4.75 6 4.75C6.41421 4.75 6.75 4.41421 6.75 4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 12.25C10.2157 12.25 8.56645 12.7308 7.34133 13.5475C6.12146 14.3608 5.25 15.5666 5.25 17C5.25 18.4334 6.12146 19.6392 7.34133 20.4525C8.56645 21.2692 10.2157 21.75 12 21.75C13.7843 21.75 15.4335 21.2692 16.6587 20.4525C17.8785 19.6392 18.75 18.4334 18.75 17C18.75 15.5666 17.8785 14.3608 16.6587 13.5475C15.4335 12.7308 13.7843 12.25 12 12.25ZM6.75 17C6.75 16.2242 7.22169 15.4301 8.17338 14.7956C9.11984 14.1646 10.4706 13.75 12 13.75C13.5294 13.75 14.8802 14.1646 15.8266 14.7956C16.7783 15.4301 17.25 16.2242 17.25 17C17.25 17.7758 16.7783 18.5699 15.8266 19.2044C14.8802 19.8354 13.5294 20.25 12 20.25C10.4706 20.25 9.11984 19.8354 8.17338 19.2044C7.22169 18.5699 6.75 17.7758 6.75 17Z"
        fill="white"
      />
      <path
        d="M19.2674 13.8393C19.3561 13.4347 19.7561 13.1787 20.1607 13.2674C21.1225 13.4783 21.9893 13.8593 22.6328 14.3859C23.2758 14.912 23.75 15.6352 23.75 16.5C23.75 17.3648 23.2758 18.088 22.6328 18.6141C21.9893 19.1407 21.1225 19.5217 20.1607 19.7326C19.7561 19.8213 19.3561 19.5653 19.2674 19.1607C19.1787 18.7561 19.4347 18.3561 19.8393 18.2674C20.6317 18.0936 21.2649 17.7952 21.6829 17.4532C22.1014 17.1108 22.25 16.7763 22.25 16.5C22.25 16.2237 22.1014 15.8892 21.6829 15.5468C21.2649 15.2048 20.6317 14.9064 19.8393 14.7326C19.4347 14.6439 19.1787 14.2439 19.2674 13.8393Z"
        fill="white"
      />
      <path
        d="M3.83935 13.2674C4.24395 13.1787 4.64387 13.4347 4.73259 13.8393C4.82132 14.2439 4.56525 14.6439 4.16065 14.7326C3.36829 14.9064 2.73505 15.2048 2.31712 15.5468C1.89863 15.8892 1.75 16.2237 1.75 16.5C1.75 16.7763 1.89863 17.1108 2.31712 17.4532C2.73505 17.7952 3.36829 18.0936 4.16065 18.2674C4.56525 18.3561 4.82132 18.7561 4.73259 19.1607C4.64387 19.5653 4.24395 19.8213 3.83935 19.7326C2.87746 19.5217 2.0107 19.1407 1.36719 18.6141C0.724248 18.088 0.25 17.3648 0.25 16.5C0.25 15.6352 0.724248 14.912 1.36719 14.3859C2.0107 13.8593 2.87746 13.4783 3.83935 13.2674Z"
        fill="white"
      />
    </svg>
  );
};

export const PrintIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M7.47276 9.53993C7.17405 9.53628 6.87534 9.53888 6.57663 9.53888C6.26489 9.53888 5.95367 9.53628 5.64193 9.53993C5.29682 9.54409 5.03877 9.79367 5.03617 10.1193C5.03304 10.4455 5.28952 10.7065 5.63098 10.7091C6.24769 10.7138 6.8644 10.7138 7.4811 10.7091C7.82412 10.7065 8.07957 10.4476 8.07748 10.1204C8.07487 9.79367 7.81839 9.54409 7.47276 9.53993ZM7.47276 9.53993C7.17405 9.53628 6.87534 9.53888 6.57663 9.53888C6.26489 9.53888 5.95367 9.53628 5.64193 9.53993C5.29682 9.54409 5.03877 9.79367 5.03617 10.1193C5.03304 10.4455 5.28952 10.7065 5.63098 10.7091C6.24769 10.7138 6.8644 10.7138 7.4811 10.7091C7.82412 10.7065 8.07957 10.4476 8.07748 10.1204C8.07487 9.79367 7.81839 9.54409 7.47276 9.53993ZM22.4896 9.80878C22.4896 9.60766 22.4812 9.4055 22.427 9.20959C22.17 8.28735 21.5955 7.63293 20.7349 7.23173C20.2907 7.02488 19.8153 6.96548 19.3273 6.98163C19.0635 6.98997 19.0562 6.97538 19.0562 6.70705C19.0552 6.1016 19.0667 5.49616 19.0536 4.89123C19.0312 3.86166 18.573 3.06031 17.7451 2.46268C17.3516 2.17819 16.9111 2.02449 16.4257 2H16.3475C16.2698 2.03178 16.1916 2.03178 16.1135 2H8.8584C8.7802 2.03178 8.70201 2.03178 8.62433 2H8.54614C8.34439 2.04012 8.13587 2.03283 7.93777 2.1016C6.73876 2.51531 5.91926 3.66002 5.91822 4.92719C5.9177 5.54461 5.91614 6.16256 5.91978 6.77999C5.92083 6.92953 5.86817 6.99518 5.71543 6.98684C5.57311 6.97955 5.42923 6.97799 5.28692 6.98684C4.60452 7.02957 3.99668 7.25987 3.48162 7.7189C2.9233 8.21597 2.55682 8.81516 2.5 9.57796V15.0468C2.50834 15.0572 2.5172 15.0681 2.51772 15.0801C2.56621 15.9497 3.04008 16.5755 3.69692 17.0762C4.25368 17.5008 4.90219 17.6655 5.60179 17.642C5.91666 17.6311 5.91718 17.6405 5.91718 17.9474C5.9177 18.6628 5.91718 19.3781 5.9177 20.094C5.9177 21.1304 6.41868 21.7676 7.4149 22H17.4788C17.6789 21.9568 17.8859 21.9583 18.0757 21.852C18.7195 21.4909 19.0401 20.9376 19.0526 20.2102C19.0661 19.4297 19.0547 18.6487 19.0568 17.8677C19.0568 17.6587 19.0724 17.6447 19.2773 17.642C19.5369 17.6384 19.7949 17.6405 20.0545 17.5998C21.3354 17.3982 22.5349 16.1639 22.4995 14.6899C22.4604 13.0637 22.4917 11.436 22.4896 9.80878ZM7.14225 4.9845C7.14642 3.93617 7.90232 3.1739 8.94702 3.17285C11.3054 3.17025 13.6638 3.17025 16.0217 3.17285C17.0685 3.1739 17.8249 3.93305 17.8296 4.98137C17.8322 5.61235 17.8254 6.24384 17.8338 6.87482C17.8353 7.01498 17.7957 7.04259 17.6623 7.04207C15.9341 7.03738 14.206 7.03895 12.4778 7.03895C10.7622 7.03895 9.04711 7.03738 7.33201 7.04207C7.19021 7.04207 7.13443 7.02071 7.13756 6.85815C7.14851 6.23342 7.14017 5.6087 7.14225 4.9845ZM17.8296 20.1482C17.8296 20.601 17.6013 20.8277 17.1456 20.8277C14.0397 20.8282 10.9337 20.8282 7.82725 20.8277C7.37059 20.8277 7.14225 20.6021 7.14225 20.1498C7.14173 18.3147 7.14434 16.4796 7.13808 14.6445C7.13756 14.4887 7.18083 14.4569 7.32888 14.4575C9.05128 14.4627 10.7732 14.4606 12.495 14.4606C14.2107 14.4606 15.9258 14.4627 17.6414 14.4575C17.7869 14.4569 17.8348 14.4846 17.8343 14.6435C17.8275 16.4786 17.8301 18.3131 17.8296 20.1482ZM21.3015 14.5518C21.301 15.6658 20.5566 16.4119 19.4467 16.414C19.0005 16.4145 19.0005 16.4145 19.0005 15.9622C19.0005 15.5131 19.0057 15.064 18.9968 14.6148C18.9942 14.4825 19.0359 14.4507 19.1589 14.458C19.2804 14.4648 19.404 14.4731 19.5254 14.4304C19.7934 14.3366 19.9628 14.0875 19.9341 13.8156C19.9044 13.5368 19.6745 13.3133 19.392 13.2909C19.3404 13.2867 19.2882 13.2888 19.2361 13.2888C14.7377 13.2888 10.2399 13.2888 5.7415 13.2898C5.65757 13.2898 5.57051 13.2872 5.49023 13.3065C5.20142 13.3748 5.01114 13.6415 5.03721 13.9271C5.06432 14.2209 5.30725 14.4465 5.61169 14.4606C5.97139 14.4767 5.97139 14.4767 5.97139 14.843C5.97139 15.3182 5.9667 15.7934 5.97504 16.2686C5.97713 16.3921 5.94116 16.4145 5.82386 16.4176C5.30933 16.4312 4.81148 16.3968 4.3814 16.0649C3.93099 15.7179 3.67816 15.262 3.67451 14.6951C3.6646 13.1069 3.66356 11.5183 3.67399 9.93018C3.68076 8.96626 4.4669 8.21389 5.45269 8.21232C7.7991 8.20815 10.1455 8.21076 12.4924 8.21076H19.4149C20.5675 8.21128 21.3015 8.94594 21.3015 10.0995C21.302 11.584 21.3026 13.0679 21.3015 14.5518ZM13.9761 18.2892C12.9825 18.2881 11.9889 18.2881 10.9952 18.2892C10.6048 18.2897 10.3379 18.5325 10.341 18.88C10.3441 19.2203 10.6079 19.4594 10.9859 19.4605C11.4863 19.462 11.9863 19.461 12.4862 19.461C12.9799 19.461 13.4735 19.4615 13.9667 19.4605C14.3634 19.4599 14.6277 19.227 14.6309 18.879C14.6335 18.5304 14.3676 18.2897 13.9761 18.2892ZM13.9745 15.7892C12.9809 15.7882 11.9873 15.7882 10.9937 15.7892C10.6043 15.7898 10.3374 16.0336 10.341 16.3811C10.3447 16.7214 10.6084 16.9595 10.9874 16.9605C11.4874 16.9621 11.9873 16.9605 12.4872 16.9605C12.9809 16.9605 13.4746 16.9616 13.9683 16.9605C14.3639 16.96 14.6288 16.7261 14.6309 16.378C14.6329 16.0294 14.3671 15.7898 13.9745 15.7892ZM7.47276 9.53993C7.17405 9.53628 6.87534 9.53888 6.57663 9.53888C6.26489 9.53888 5.95367 9.53628 5.64193 9.53993C5.29682 9.54409 5.03877 9.79367 5.03617 10.1193C5.03304 10.4455 5.28952 10.7065 5.63098 10.7091C6.24769 10.7138 6.8644 10.7138 7.4811 10.7091C7.82412 10.7065 8.07957 10.4476 8.07748 10.1204C8.07487 9.79367 7.81839 9.54409 7.47276 9.53993Z"
        fill="white"
      />
      <path
        d="M8.85907 2C8.78087 2.05575 8.7032 2.06513 8.625 2C8.70267 2 8.78087 2 8.85907 2Z"
        fill="white"
      />
      <path
        d="M16.3473 2C16.2692 2.06513 16.1915 2.05575 16.1133 2C16.1915 2 16.2697 2 16.3473 2Z"
        fill="white"
      />
      <path
        d="M8.07845 10.1214C8.08054 10.4487 7.8251 10.7076 7.48207 10.7102C6.86537 10.7149 6.24866 10.7149 5.63195 10.7102C5.29049 10.7076 5.03401 10.4466 5.03714 10.1204C5.03974 9.79475 5.29779 9.54517 5.6429 9.54101C5.95464 9.53736 6.26586 9.53996 6.5776 9.53996C6.87631 9.53996 7.17502 9.53736 7.47373 9.54101C7.81936 9.54517 8.07584 9.79475 8.07845 10.1214Z"
        fill="white"
      />
      <path
        d="M10.3409 16.3817C10.3372 16.0342 10.6041 15.7904 10.9935 15.7898C11.9871 15.7888 12.9808 15.7888 13.9744 15.7898C14.3669 15.7904 14.6328 16.03 14.6307 16.3786C14.6286 16.7267 14.3638 16.9606 13.9681 16.9611C13.4744 16.9622 12.9808 16.9611 12.4871 16.9611C11.9871 16.9611 11.4872 16.9627 10.9873 16.9611C10.6083 16.9601 10.3445 16.722 10.3409 16.3817Z"
        fill="white"
      />
      <path
        d="M14.6307 18.8797C14.6276 19.2277 14.3633 19.4606 13.9665 19.4611C13.4734 19.4622 12.9797 19.4617 12.486 19.4617C11.9861 19.4617 11.4862 19.4627 10.9857 19.4611C10.6078 19.4601 10.344 19.2209 10.3408 18.8807C10.3377 18.5332 10.6046 18.2904 10.9951 18.2898C11.9887 18.2888 12.9823 18.2888 13.9759 18.2898C14.3674 18.2904 14.6333 18.5311 14.6307 18.8797Z"
        fill="white"
      />
      <path
        d="M8.07845 10.1214C8.08054 10.4487 7.8251 10.7076 7.48207 10.7102C6.86537 10.7149 6.24866 10.7149 5.63195 10.7102C5.29049 10.7076 5.03401 10.4466 5.03714 10.1204C5.03974 9.79475 5.29779 9.54517 5.6429 9.54101C5.95464 9.53736 6.26586 9.53996 6.5776 9.53996C6.87631 9.53996 7.17502 9.53736 7.47373 9.54101C7.81936 9.54517 8.07584 9.79475 8.07845 10.1214Z"
        fill="white"
      />
      <path
        d="M14.6307 16.3786C14.6286 16.7267 14.3638 16.9606 13.9681 16.9611C13.4744 16.9622 12.9808 16.9611 12.4871 16.9611C11.9871 16.9611 11.4872 16.9627 10.9873 16.9611C10.6083 16.9601 10.3445 16.722 10.3409 16.3817C10.3372 16.0342 10.6041 15.7904 10.9935 15.7898C11.9871 15.7888 12.9808 15.7888 13.9744 15.7898C14.3669 15.7904 14.6328 16.03 14.6307 16.3786Z"
        fill="white"
      />
      <path
        d="M14.6307 18.8797C14.6276 19.2277 14.3633 19.4606 13.9665 19.4611C13.4734 19.4622 12.9797 19.4617 12.486 19.4617C11.9861 19.4617 11.4862 19.4627 10.9857 19.4611C10.6078 19.4601 10.344 19.2209 10.3408 18.8807C10.3377 18.5332 10.6046 18.2904 10.9951 18.2898C11.9887 18.2888 12.9823 18.2888 13.9759 18.2898C14.3674 18.2904 14.6333 18.5311 14.6307 18.8797Z"
        fill="white"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0437 16.2766C11.6072 16.2766 11.2529 15.9224 11.2529 15.4859V2.79075C11.2529 2.35425 11.6072 2 12.0437 2C12.4802 2 12.8344 2.35425 12.8344 2.79075V15.4859C12.8344 15.9224 12.4802 16.2766 12.0437 16.2766Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0432 16.2777C11.8334 16.2777 11.631 16.1944 11.4834 16.0447L8.40895 12.9587C8.10109 12.6487 8.10214 12.1479 8.41106 11.84C8.72103 11.5321 9.22078 11.5321 9.52865 11.8421L12.0432 14.3672L14.5578 11.8421C14.8656 11.5321 15.3654 11.5321 15.6754 11.84C15.9843 12.1479 15.9853 12.6487 15.6775 12.9587L12.6031 16.0447C12.4555 16.1944 12.253 16.2777 12.0432 16.2777Z"
        fill="white"
      />
      <mask
        id="mask0_3149_211926"
        maskUnits="userSpaceOnUse"
        x="1"
        y="6"
        width="22"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 6.98828H22.5863V21.479H1.5V6.98828Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3149_211926)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9211 21.479H6.17594C3.59811 21.479 1.5 19.3819 1.5 16.803V11.6526C1.5 9.08007 3.59284 6.98828 6.16645 6.98828H7.15857C7.59507 6.98828 7.94932 7.34254 7.94932 7.77903C7.94932 8.21552 7.59507 8.56977 7.15857 8.56977H6.16645C4.46477 8.56977 3.08149 9.95199 3.08149 11.6526V16.803C3.08149 18.51 4.46899 19.8975 6.17594 19.8975H17.9211C19.6207 19.8975 21.0051 18.5131 21.0051 16.8136V11.6642C21.0051 9.95727 19.6165 8.56977 17.9117 8.56977H16.929C16.4925 8.56977 16.1383 8.21552 16.1383 7.77903C16.1383 7.34254 16.4925 6.98828 16.929 6.98828H17.9117C20.4895 6.98828 22.5865 9.08639 22.5865 11.6642V16.8136C22.5865 19.3861 20.4926 21.479 17.9211 21.479Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const EventLocationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.8537 13.134L9.46025 12.8254L9.8537 13.134ZM6.14598 13.134L5.75253 13.4425L6.14598 13.134ZM7.99984 14.6706V14.1706V14.6706ZM12.8332 6.40612C12.8332 7.22379 12.4068 8.3179 11.7357 9.50434C11.0756 10.6712 10.2226 11.8532 9.46025 12.8254L10.2471 13.4425C11.0246 12.4511 11.9113 11.225 12.6061 9.99667C13.2898 8.78795 13.8332 7.49994 13.8332 6.40612H12.8332ZM6.53943 12.8254C5.77703 11.8532 4.92403 10.6712 4.26401 9.50434C3.59292 8.3179 3.1665 7.22379 3.1665 6.40612H2.1665C2.1665 7.49994 2.70991 8.78795 3.3936 9.99667C4.08835 11.225 4.97509 12.4511 5.75253 13.4425L6.53943 12.8254ZM3.1665 6.40612C3.1665 3.47747 5.36436 1.16699 7.99984 1.16699V0.166992C4.74428 0.166992 2.1665 2.99551 2.1665 6.40612H3.1665ZM7.99984 1.16699C10.6353 1.16699 12.8332 3.47747 12.8332 6.40612H13.8332C13.8332 2.99551 11.2554 0.166992 7.99984 0.166992V1.16699ZM9.46025 12.8254C9.04761 13.3516 8.77592 13.6954 8.53263 13.9164C8.31074 14.1179 8.16262 14.1706 7.99984 14.1706V15.1706C8.48588 15.1706 8.86301 14.9672 9.20501 14.6566C9.5256 14.3654 9.85643 13.9408 10.2471 13.4425L9.46025 12.8254ZM5.75253 13.4425C6.14324 13.9408 6.47408 14.3654 6.79467 14.6566C7.13666 14.9672 7.5138 15.1706 7.99984 15.1706V14.1706C7.83705 14.1706 7.68894 14.1179 7.46705 13.9164C7.22375 13.6954 6.95207 13.3516 6.53943 12.8254L5.75253 13.4425ZM5.49984 6.66699C5.49984 8.0477 6.61913 9.16699 7.99984 9.16699V8.16699C7.17141 8.16699 6.49984 7.49542 6.49984 6.66699H5.49984ZM7.99984 9.16699C9.38055 9.16699 10.4998 8.0477 10.4998 6.66699H9.49984C9.49984 7.49542 8.82826 8.16699 7.99984 8.16699V9.16699ZM10.4998 6.66699C10.4998 5.28628 9.38055 4.16699 7.99984 4.16699V5.16699C8.82826 5.16699 9.49984 5.83857 9.49984 6.66699H10.4998ZM7.99984 4.16699C6.61913 4.16699 5.49984 5.28628 5.49984 6.66699H6.49984C6.49984 5.83857 7.17141 5.16699 7.99984 5.16699V4.16699Z"
        fill="#A8A9BA"
      />
    </svg>
  );
};

export const EventCalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.3335 3.83301C5.06016 3.83301 4.8335 3.60634 4.8335 3.33301V1.33301C4.8335 1.05967 5.06016 0.833008 5.3335 0.833008C5.60683 0.833008 5.8335 1.05967 5.8335 1.33301V3.33301C5.8335 3.60634 5.60683 3.83301 5.3335 3.83301Z"
        fill="#A8A9BA"
      />
      <path
        d="M10.6665 3.83301C10.3932 3.83301 10.1665 3.60634 10.1665 3.33301V1.33301C10.1665 1.05967 10.3932 0.833008 10.6665 0.833008C10.9398 0.833008 11.1665 1.05967 11.1665 1.33301V3.33301C11.1665 3.60634 10.9398 3.83301 10.6665 3.83301Z"
        fill="#A8A9BA"
      />
      <path
        d="M5.66667 9.66655C5.58 9.66655 5.49333 9.64656 5.41333 9.61322C5.32667 9.57989 5.26 9.53321 5.19333 9.47321C5.07333 9.34654 5 9.17988 5 8.99988C5 8.91322 5.02 8.82655 5.05333 8.74655C5.08667 8.66655 5.13333 8.59322 5.19333 8.52655C5.26 8.46655 5.32667 8.41987 5.41333 8.38654C5.65333 8.28654 5.95333 8.33989 6.14 8.52655C6.26 8.65322 6.33333 8.82655 6.33333 8.99988C6.33333 9.03988 6.32667 9.08656 6.32 9.13322C6.31333 9.17322 6.3 9.21322 6.28 9.25322C6.26667 9.29322 6.24667 9.33321 6.22 9.37321C6.2 9.40655 6.16667 9.43988 6.14 9.47321C6.01333 9.59321 5.84 9.66655 5.66667 9.66655Z"
        fill="#A8A9BA"
      />
      <path
        d="M8.00016 9.66658C7.9135 9.66658 7.82683 9.64659 7.74683 9.61326C7.66016 9.57992 7.5935 9.53324 7.52683 9.47324C7.40683 9.34658 7.3335 9.17992 7.3335 8.99992C7.3335 8.91325 7.3535 8.82658 7.38683 8.74658C7.42016 8.66658 7.46683 8.59325 7.52683 8.52659C7.5935 8.46659 7.66016 8.41991 7.74683 8.38657C7.98683 8.27991 8.28683 8.33992 8.4735 8.52659C8.5935 8.65325 8.66683 8.82658 8.66683 8.99992C8.66683 9.03992 8.66016 9.08659 8.6535 9.13326C8.64683 9.17326 8.63349 9.21325 8.61349 9.25325C8.60016 9.29325 8.58016 9.33325 8.5535 9.37325C8.5335 9.40658 8.50016 9.43991 8.4735 9.47324C8.34683 9.59324 8.1735 9.66658 8.00016 9.66658Z"
        fill="#A8A9BA"
      />
      <path
        d="M10.3332 9.66658C10.2465 9.66658 10.1598 9.64659 10.0798 9.61326C9.99317 9.57992 9.9265 9.53324 9.85984 9.47324C9.83317 9.43991 9.8065 9.40658 9.77984 9.37325C9.75317 9.33325 9.73317 9.29325 9.71984 9.25325C9.69984 9.21325 9.6865 9.17326 9.67984 9.13326C9.67317 9.08659 9.6665 9.03992 9.6665 8.99992C9.6665 8.82658 9.73984 8.65325 9.85984 8.52659C9.9265 8.46659 9.99317 8.41991 10.0798 8.38657C10.3265 8.27991 10.6198 8.33992 10.8065 8.52659C10.9265 8.65325 10.9998 8.82658 10.9998 8.99992C10.9998 9.03992 10.9932 9.08659 10.9865 9.13326C10.9798 9.17326 10.9665 9.21325 10.9465 9.25325C10.9332 9.29325 10.9132 9.33325 10.8865 9.37325C10.8665 9.40658 10.8332 9.43991 10.8065 9.47324C10.6798 9.59324 10.5065 9.66658 10.3332 9.66658Z"
        fill="#A8A9BA"
      />
      <path
        d="M5.66667 11.9998C5.58 11.9998 5.49333 11.9798 5.41333 11.9465C5.33333 11.9131 5.26 11.8665 5.19333 11.8065C5.07333 11.6798 5 11.5065 5 11.3331C5 11.2465 5.02 11.1598 5.05333 11.0798C5.08667 10.9931 5.13333 10.9198 5.19333 10.8598C5.44 10.6131 5.89333 10.6131 6.14 10.8598C6.26 10.9865 6.33333 11.1598 6.33333 11.3331C6.33333 11.5065 6.26 11.6798 6.14 11.8065C6.01333 11.9265 5.84 11.9998 5.66667 11.9998Z"
        fill="#A8A9BA"
      />
      <path
        d="M8.00016 11.9998C7.82683 11.9998 7.6535 11.9265 7.52683 11.8065C7.40683 11.6798 7.3335 11.5065 7.3335 11.3331C7.3335 11.2465 7.3535 11.1598 7.38683 11.0798C7.42016 10.9931 7.46683 10.9198 7.52683 10.8598C7.7735 10.6131 8.22683 10.6131 8.4735 10.8598C8.5335 10.9198 8.58016 10.9931 8.61349 11.0798C8.64683 11.1598 8.66683 11.2465 8.66683 11.3331C8.66683 11.5065 8.5935 11.6798 8.4735 11.8065C8.34683 11.9265 8.1735 11.9998 8.00016 11.9998Z"
        fill="#A8A9BA"
      />
      <path
        d="M10.3332 11.9999C10.1598 11.9999 9.9865 11.9266 9.85984 11.8066C9.79984 11.7466 9.75317 11.6733 9.71984 11.5866C9.68651 11.5066 9.6665 11.4199 9.6665 11.3333C9.6665 11.2466 9.68651 11.1599 9.71984 11.0799C9.75317 10.9933 9.79984 10.9199 9.85984 10.8599C10.0132 10.7066 10.2465 10.6333 10.4598 10.6799C10.5065 10.6866 10.5465 10.6999 10.5865 10.7199C10.6265 10.7333 10.6665 10.7533 10.7065 10.78C10.7398 10.8 10.7732 10.8333 10.8065 10.8599C10.9265 10.9866 10.9998 11.1599 10.9998 11.3333C10.9998 11.5066 10.9265 11.6799 10.8065 11.8066C10.6798 11.9266 10.5065 11.9999 10.3332 11.9999Z"
        fill="#A8A9BA"
      />
      <path
        d="M13.6668 6.55957H2.3335C2.06016 6.55957 1.8335 6.3329 1.8335 6.05957C1.8335 5.78624 2.06016 5.55957 2.3335 5.55957H13.6668C13.9402 5.55957 14.1668 5.78624 14.1668 6.05957C14.1668 6.3329 13.9402 6.55957 13.6668 6.55957Z"
        fill="#A8A9BA"
      />
      <path
        d="M10.6667 15.1663H5.33333C2.9 15.1663 1.5 13.7663 1.5 11.333V5.66634C1.5 3.23301 2.9 1.83301 5.33333 1.83301H10.6667C13.1 1.83301 14.5 3.23301 14.5 5.66634V11.333C14.5 13.7663 13.1 15.1663 10.6667 15.1663ZM5.33333 2.83301C3.42667 2.83301 2.5 3.75967 2.5 5.66634V11.333C2.5 13.2397 3.42667 14.1663 5.33333 14.1663H10.6667C12.5733 14.1663 13.5 13.2397 13.5 11.333V5.66634C13.5 3.75967 12.5733 2.83301 10.6667 2.83301H5.33333Z"
        fill="#A8A9BA"
      />
    </svg>
  );
};

export const EventTimeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 16C3.58698 16 0 12.413 0 8C0 3.58698 3.58698 0 8 0C12.413 0 16 3.58698 16 8C16 12.413 12.413 16 8 16ZM8 1.11628C4.20465 1.11628 1.11628 4.20465 1.11628 8C1.11628 11.7953 4.20465 14.8837 8 14.8837C11.7953 14.8837 14.8837 11.7953 14.8837 8C14.8837 4.20465 11.7953 1.11628 8 1.11628Z"
        fill="#A8A9BA"
      />
      <path
        d="M10.9678 11.1436C10.8638 11.1436 10.7598 11.1196 10.6638 11.0556L8.18382 9.57562C7.56782 9.20762 7.11182 8.39962 7.11182 7.68762V4.40762C7.11182 4.07962 7.38382 3.80762 7.71182 3.80762C8.03982 3.80762 8.31182 4.07962 8.31182 4.40762V7.68762C8.31182 7.97562 8.55182 8.39962 8.79982 8.54362L11.2798 10.0236C11.5678 10.1916 11.6558 10.5596 11.4878 10.8476C11.3678 11.0396 11.1678 11.1436 10.9678 11.1436Z"
        fill="#A8A9BA"
      />
    </svg>
  );
};

export const WatchEyeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.6822 9.07251C4.91208 7.35567 7.27166 5.00586 10.974 5.00586C14.6763 5.00586 17.0359 7.35567 18.2658 9.07251C18.7539 9.75391 18.998 10.0946 18.9781 10.7901C18.9582 11.4855 18.6808 11.8294 18.126 12.5172C16.736 14.2406 14.2024 16.6725 10.974 16.6725C7.74558 16.6725 5.21201 14.2406 3.82194 12.5172C3.26714 11.8294 2.98974 11.4855 2.96987 10.7901C2.95 10.0946 3.19407 9.75391 3.6822 9.07251ZM10.9731 14.1721C12.814 14.1721 14.3064 12.6797 14.3064 10.8387C14.3064 8.99779 12.814 7.5054 10.9731 7.5054C9.13213 7.5054 7.63974 8.99779 7.63974 10.8387C7.63974 12.6797 9.13213 14.1721 10.9731 14.1721Z"
        fill="white"
      />
    </svg>
  );
};

export const BtnChatIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M10.4993 18.3811C9.96447 18.3811 9.46059 18.1098 9.104 17.637L7.94121 16.0866C7.91795 16.0556 7.82493 16.0168 7.78617 16.0091H7.39857C4.16602 16.0091 2.16602 15.1331 2.16602 10.7765V6.90053C2.16602 3.47417 3.97222 1.66797 7.39857 1.66797H13.6001C17.0265 1.66797 18.8327 3.47417 18.8327 6.90053V10.7765C18.8327 14.2029 17.0265 16.0091 13.6001 16.0091H13.2125C13.1505 16.0091 13.0962 16.0401 13.0575 16.0866L11.8947 17.637C11.5381 18.1098 11.0342 18.3811 10.4993 18.3811ZM7.39857 2.83076C4.62338 2.83076 3.32881 4.12533 3.32881 6.90053V10.7765C3.32881 14.2804 4.53036 14.8463 7.39857 14.8463H7.78617C8.18152 14.8463 8.63113 15.0711 8.87144 15.3889L10.0342 16.9393C10.3056 17.2959 10.6931 17.2959 10.9645 16.9393L12.1273 15.3889C12.3831 15.0478 12.7862 14.8463 13.2125 14.8463H13.6001C16.3753 14.8463 17.6699 13.5517 17.6699 10.7765V6.90053C17.6699 4.12533 16.3753 2.83076 13.6001 2.83076H7.39857Z"
        fill="white"
      />
      <path
        d="M10.4998 10.0016C10.0657 10.0016 9.72461 9.65272 9.72461 9.22637C9.72461 8.80001 10.0734 8.45117 10.4998 8.45117C10.9262 8.45117 11.275 8.80001 11.275 9.22637C11.275 9.65272 10.9339 10.0016 10.4998 10.0016Z"
        fill="white"
      />
      <path
        d="M13.5994 10.0016C13.1653 10.0016 12.8242 9.65272 12.8242 9.22637C12.8242 8.80001 13.1731 8.45117 13.5994 8.45117C14.0258 8.45117 14.3746 8.80001 14.3746 9.22637C14.3746 9.65272 14.0335 10.0016 13.5994 10.0016Z"
        fill="white"
      />
      <path
        d="M7.39824 10.0016C6.96413 10.0016 6.62305 9.65272 6.62305 9.22637C6.62305 8.80001 6.97188 8.45117 7.39824 8.45117C7.8246 8.45117 8.17343 8.80001 8.17343 9.22637C8.17343 9.65272 7.83235 10.0016 7.39824 10.0016Z"
        fill="white"
      />
    </svg>
  );
};
export const BtnChatIconBlack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M10.4993 18.3346C9.96447 18.3346 9.46059 18.0641 9.104 17.5925L7.94121 16.0464C7.91795 16.0155 7.82493 15.9769 7.78617 15.9691H7.39857C4.16602 15.9691 2.16602 15.0956 2.16602 10.7511V6.88597C2.16602 3.46914 3.97222 1.66797 7.39857 1.66797H13.6001C17.0265 1.66797 18.8327 3.46914 18.8327 6.88597V10.7511C18.8327 14.168 17.0265 15.9691 13.6001 15.9691H13.2125C13.1505 15.9691 13.0962 16.0001 13.0575 16.0464L11.8947 17.5925C11.5381 18.0641 11.0342 18.3346 10.4993 18.3346ZM7.39857 2.82752C4.62338 2.82752 3.32881 4.11849 3.32881 6.88597V10.7511C3.32881 14.2453 4.53036 14.8096 7.39857 14.8096H7.78617C8.18152 14.8096 8.63113 15.0338 8.87144 15.3507L10.0342 16.8968C10.3056 17.2524 10.6931 17.2524 10.9645 16.8968L12.1273 15.3507C12.3831 15.0106 12.7862 14.8096 13.2125 14.8096H13.6001C16.3753 14.8096 17.6699 13.5186 17.6699 10.7511V6.88597C17.6699 4.11849 16.3753 2.82752 13.6001 2.82752H7.39857Z"
        fill="#0C1033"
      />
      <path
        d="M14.6673 7.29297H6.33398C5.99232 7.29297 5.70898 7.00964 5.70898 6.66797C5.70898 6.3263 5.99232 6.04297 6.33398 6.04297H14.6673C15.009 6.04297 15.2923 6.3263 15.2923 6.66797C15.2923 7.00964 15.009 7.29297 14.6673 7.29297Z"
        fill="#0C1033"
      />
      <path
        d="M11.334 11.457H6.33398C5.99232 11.457 5.70898 11.1737 5.70898 10.832C5.70898 10.4904 5.99232 10.207 6.33398 10.207H11.334C11.6757 10.207 11.959 10.4904 11.959 10.832C11.959 11.1737 11.6757 11.457 11.334 11.457Z"
        fill="#0C1033"
      />
    </svg>
  );
};

export const BtnTicketIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.59202 4.71799L4.36502 4.27248L4.36502 4.27248L4.59202 4.71799ZM3.71799 5.59202L3.27248 5.36502L3.27248 5.36502L3.71799 5.59202ZM3.71799 18.408L4.16349 18.181H4.16349L3.71799 18.408ZM4.59202 19.282L4.81901 18.8365H4.81901L4.59202 19.282ZM19.408 19.282L19.181 18.8365H19.181L19.408 19.282ZM20.282 18.408L19.8365 18.181V18.181L20.282 18.408ZM20.2692 14.4187L20.2546 13.919H20.2546L20.2692 14.4187ZM20.0356 14.4256L20.0502 14.9254L20.0356 14.4256ZM20.282 5.59202L19.8365 5.81901V5.81901L20.282 5.59202ZM19.408 4.71799L19.181 5.16349V5.16349L19.408 4.71799ZM6.7 5H12.25V4H6.7V5ZM4.81901 5.16349C4.95069 5.0964 5.12454 5.05031 5.42712 5.02559C5.73554 5.00039 6.1317 5 6.7 5V4C6.1482 4 5.70428 3.99961 5.34569 4.02891C4.98126 4.05868 4.66117 4.12159 4.36502 4.27248L4.81901 5.16349ZM4.16349 5.81901C4.3073 5.53677 4.53677 5.3073 4.81901 5.16349L4.36502 4.27248C3.89462 4.51217 3.51217 4.89462 3.27248 5.36502L4.16349 5.81901ZM4 7.7C4 7.1317 4.00039 6.73554 4.02559 6.42712C4.05031 6.12454 4.0964 5.95069 4.16349 5.81901L3.27248 5.36502C3.12159 5.66117 3.05868 5.98126 3.02891 6.34569C2.99961 6.70428 3 7.1482 3 7.7H4ZM4 9.26923V7.7H3V9.26923H4ZM3.73077 9C3.87946 9 4 9.12054 4 9.26923H3C3 9.67282 3.32718 10 3.73077 10V9ZM4 9H3.73077V10H4V9ZM7 12C7 10.3431 5.65685 9 4 9V10C5.10457 10 6 10.8954 6 12H7ZM4 15C5.65685 15 7 13.6569 7 12H6C6 13.1046 5.10457 14 4 14V15ZM3.73077 15H4V14H3.73077V15ZM4 14.7308C4 14.8795 3.87946 15 3.73077 15V14C3.32718 14 3 14.3272 3 14.7308H4ZM4 16.3V14.7308H3V16.3H4ZM4.16349 18.181C4.0964 18.0493 4.05031 17.8755 4.02559 17.5729C4.00039 17.2645 4 16.8683 4 16.3H3C3 16.8518 2.99961 17.2957 3.02891 17.6543C3.05868 18.0187 3.12159 18.3388 3.27248 18.635L4.16349 18.181ZM4.81901 18.8365C4.53677 18.6927 4.3073 18.4632 4.16349 18.181L3.27248 18.635C3.51217 19.1054 3.89462 19.4878 4.36502 19.7275L4.81901 18.8365ZM6.7 19C6.1317 19 5.73554 18.9996 5.42712 18.9744C5.12454 18.9497 4.95069 18.9036 4.81901 18.8365L4.36502 19.7275C4.66117 19.8784 4.98126 19.9413 5.34569 19.9711C5.70428 20.0004 6.1482 20 6.7 20V19ZM12.25 19H6.7V20H12.25V19ZM13 19.25V19H12V19.25H13ZM13 19C13 18.7239 13.2239 18.5 13.5 18.5V17.5C12.6716 17.5 12 18.1716 12 19H13ZM13.5 18.5C13.7761 18.5 14 18.7239 14 19H15C15 18.1716 14.3284 17.5 13.5 17.5V18.5ZM14 19V19.25H15V19H14ZM17.3 19H14.75V20H17.3V19ZM19.181 18.8365C19.0493 18.9036 18.8755 18.9497 18.5729 18.9744C18.2645 18.9996 17.8683 19 17.3 19V20C17.8518 20 18.2957 20.0004 18.6543 19.9711C19.0187 19.9413 19.3388 19.8784 19.635 19.7275L19.181 18.8365ZM19.8365 18.181C19.6927 18.4632 19.4632 18.6927 19.181 18.8365L19.635 19.7275C20.1054 19.4878 20.4878 19.1054 20.7275 18.635L19.8365 18.181ZM20 16.3C20 16.8683 19.9996 17.2645 19.9744 17.5729C19.9497 17.8755 19.9036 18.0493 19.8365 18.181L20.7275 18.635C20.8784 18.3388 20.9413 18.0187 20.9711 17.6543C21.0004 17.2957 21 16.8518 21 16.3H20ZM20 14.6428V16.3H21V14.6428H20ZM20.2839 14.9185C20.1285 14.9231 20 14.7983 20 14.6428H21C21 14.2346 20.6627 13.907 20.2546 13.919L20.2839 14.9185ZM20.0502 14.9254L20.2839 14.9185L20.2546 13.919L20.0209 13.9258L20.0502 14.9254ZM17 11.9633C17 13.634 18.3803 14.9744 20.0502 14.9254L20.0209 13.9258C18.9145 13.9583 18 13.0702 18 11.9633H17ZM19.9633 9C18.3267 9 17 10.3267 17 11.9633H18C18 10.879 18.879 10 19.9633 10V9ZM20.2692 9H19.9633V10H20.2692V9ZM20 9.26923C20 9.12054 20.1205 9 20.2692 9V10C20.6728 10 21 9.67283 21 9.26923H20ZM20 7.7V9.26923H21V7.7H20ZM19.8365 5.81901C19.9036 5.95069 19.9497 6.12454 19.9744 6.42712C19.9996 6.73554 20 7.1317 20 7.7H21C21 7.1482 21.0004 6.70428 20.9711 6.34569C20.9413 5.98126 20.8784 5.66117 20.7275 5.36502L19.8365 5.81901ZM19.181 5.16349C19.4632 5.3073 19.6927 5.53677 19.8365 5.81901L20.7275 5.36502C20.4878 4.89462 20.1054 4.51217 19.635 4.27248L19.181 5.16349ZM17.3 5C17.8683 5 18.2645 5.00039 18.5729 5.02559C18.8755 5.05031 19.0493 5.0964 19.181 5.16349L19.635 4.27248C19.3388 4.12159 19.0187 4.05868 18.6543 4.02891C18.2957 3.99961 17.8518 4 17.3 4V5ZM14.75 5H17.3V4H14.75V5ZM14 4.75V5H15V4.75H14ZM14 5C14 5.27614 13.7761 5.5 13.5 5.5V6.5C14.3284 6.5 15 5.82843 15 5H14ZM13.5 5.5C13.2239 5.5 13 5.27614 13 5H12C12 5.82843 12.6716 6.5 13.5 6.5V5.5ZM13 5V4.75H12V5H13ZM13.5 8.5C13.7761 8.5 14 8.72386 14 9H15C15 8.17157 14.3284 7.5 13.5 7.5V8.5ZM13 9C13 8.72386 13.2239 8.5 13.5 8.5V7.5C12.6716 7.5 12 8.17157 12 9H13ZM13 10V9H12V10H13ZM13.5 10.5C13.2239 10.5 13 10.2761 13 10H12C12 10.8284 12.6716 11.5 13.5 11.5V10.5ZM14 10C14 10.2761 13.7761 10.5 13.5 10.5V11.5C14.3284 11.5 15 10.8284 15 10H14ZM14 9V10H15V9H14ZM13.5 13.5C13.7761 13.5 14 13.7239 14 14H15C15 13.1716 14.3284 12.5 13.5 12.5V13.5ZM13 14C13 13.7239 13.2239 13.5 13.5 13.5V12.5C12.6716 12.5 12 13.1716 12 14H13ZM13 15V14H12V15H13ZM13.5 15.5C13.2239 15.5 13 15.2761 13 15H12C12 15.8284 12.6716 16.5 13.5 16.5V15.5ZM14 15C14 15.2761 13.7761 15.5 13.5 15.5V16.5C14.3284 16.5 15 15.8284 15 15H14ZM14 14V15H15V14H14ZM14 19.25C14 19.6642 14.3358 20 14.75 20V19C14.8881 19 15 19.1119 15 19.25H14ZM14.75 4C14.3358 4 14 4.33579 14 4.75H15C15 4.88807 14.8881 5 14.75 5V4ZM12.25 20C12.6642 20 13 19.6642 13 19.25H12C12 19.1119 12.1119 19 12.25 19V20ZM12.25 5C12.1119 5 12 4.88807 12 4.75H13C13 4.33579 12.6642 4 12.25 4V5Z"
        fill="#0C1033"
      />
    </svg>
  );
};

export const DollarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M9.53268 11.2833H8.28268C7.32435 11.2833 6.54935 10.4833 6.54935 9.49167C6.54935 9.15 6.83268 8.86667 7.17435 8.86667C7.51602 8.86667 7.79935 9.15 7.79935 9.49167C7.79935 9.79167 8.01602 10.0333 8.28268 10.0333H9.53268C9.72435 10.0333 9.87435 9.85833 9.87435 9.64167C9.87435 9.35 9.82435 9.33333 9.63268 9.26667L7.62435 8.56667C6.89935 8.31667 6.54102 7.80833 6.54102 7.01667C6.54102 6.11667 7.25768 5.375 8.13268 5.375H9.38268C10.341 5.375 11.116 6.175 11.116 7.16667C11.116 7.50833 10.8327 7.79167 10.491 7.79167C10.1493 7.79167 9.86602 7.50833 9.86602 7.16667C9.86602 6.86667 9.64935 6.625 9.38268 6.625H8.13268C7.94102 6.625 7.79102 6.8 7.79102 7.01667C7.79102 7.30833 7.84102 7.325 8.03268 7.39167L10.041 8.09167C10.766 8.35 11.116 8.85833 11.116 9.64167C11.1243 10.55 10.4077 11.2833 9.53268 11.2833Z"
        fill="#0C1033"
      />
      <path
        d="M8.83398 11.9507C8.49232 11.9507 8.20898 11.6673 8.20898 11.3257V10.709C8.20898 10.3673 8.49232 10.084 8.83398 10.084C9.17565 10.084 9.45898 10.3673 9.45898 10.709V11.3257C9.45898 11.6757 9.17565 11.9507 8.83398 11.9507Z"
        fill="#0C1033"
      />
      <path
        d="M8.83398 6.6168C8.49232 6.6168 8.20898 6.33346 8.20898 5.9918V5.3418C8.20898 5.00013 8.49232 4.7168 8.83398 4.7168C9.17565 4.7168 9.45898 5.00013 9.45898 5.3418V5.9918C9.45898 6.33346 9.17565 6.6168 8.83398 6.6168Z"
        fill="#0C1033"
      />
      <path
        d="M8.82435 15.5999C4.80768 15.5999 1.54102 12.3332 1.54102 8.31654C1.54102 4.29987 4.80768 1.0332 8.82435 1.0332C12.841 1.0332 16.1077 4.29987 16.1077 8.31654C16.1077 12.3332 12.8327 15.5999 8.82435 15.5999ZM8.82435 2.29154C5.49935 2.29154 2.79102 4.99987 2.79102 8.32487C2.79102 11.6499 5.49935 14.3499 8.82435 14.3499C12.1493 14.3499 14.8577 11.6415 14.8577 8.31654C14.8577 4.99154 12.1493 2.29154 8.82435 2.29154Z"
        fill="#0C1033"
      />
      <path
        d="M14.6842 18.9326C13.1425 18.9326 11.6925 18.1826 10.8008 16.9159C10.6008 16.6326 10.6675 16.2409 10.9508 16.0409C11.2342 15.8409 11.6258 15.9076 11.8258 16.1909C12.4842 17.1243 13.5508 17.6743 14.6842 17.6743C16.6175 17.6743 18.1842 16.1076 18.1842 14.1743C18.1842 13.0493 17.6342 11.9826 16.7175 11.3243C16.4342 11.1243 16.3758 10.7326 16.5758 10.4493C16.7758 10.1659 17.1675 10.1076 17.4508 10.3076C18.6925 11.1993 19.4342 12.6409 19.4342 14.1743C19.4342 16.8076 17.3092 18.9326 14.6842 18.9326Z"
        fill="#0C1033"
      />
    </svg>
  );
};

export const GratitudeHeadingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 34 34"
      fill="none"
    >
      <g opacity="0.36" filter="url(#filter0_b_3602_15516)">
        <circle
          cx="16.6455"
          cy="16.6455"
          r="16.6455"
          fill="url(#paint0_linear_3602_15516)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.672 10.8457C13.672 9.153 15.0442 7.78076 16.737 7.78076C18.4297 7.78076 19.8019 9.153 19.8019 10.8457C19.8019 12.5385 18.4297 13.9107 16.737 13.9107C15.0442 13.9107 13.672 12.5385 13.672 10.8457ZM10.8188 15.6654C11.4411 15.0747 12.2663 14.7455 13.1243 14.7455C13.9823 14.7455 14.8075 15.0747 15.4298 15.6654L15.4434 15.6786L16.4867 16.7219H15.4566L15.4567 16.722H16.4869L16.7388 16.974L16.9907 16.722H18.0208L18.021 16.7219H16.9908L18.0341 15.6786L18.0477 15.6654C18.67 15.0747 19.4953 14.7455 20.3532 14.7455C21.2112 14.7455 22.0364 15.0747 22.6587 15.6654L22.6589 15.6655C22.9684 15.9595 23.2149 16.3133 23.3834 16.7056C23.5518 17.0978 23.6387 17.5202 23.6387 17.9471C23.6387 18.374 23.5518 18.7964 23.3834 19.1887C23.2155 19.5795 22.9702 19.9323 22.6621 20.2256L17.2465 25.4895C16.9638 25.7643 16.5138 25.7643 16.2311 25.4895L10.8154 20.2256C10.5074 19.9323 10.262 19.5795 10.0942 19.1887C9.92573 18.7964 9.83887 18.374 9.83887 17.9471C9.83887 17.5202 9.92573 17.0978 10.0942 16.7056C10.2626 16.3133 10.5091 15.9595 10.8187 15.6655L10.8188 15.6654ZM16.9908 16.7219L16.9907 16.722H16.4869L16.4867 16.7219H16.9908Z"
        fill="url(#paint1_linear_3602_15516)"
      />
      <defs>
        <filter
          id="filter0_b_3602_15516"
          x="-22.552"
          y="-22.552"
          width="78.3949"
          height="78.3949"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="11.276" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_3602_15516"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3602_15516"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3602_15516"
          x1="-6.89598"
          y1="4.99364"
          x2="36.62"
          y2="19.0234"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3602_15516"
          x1="6.98034"
          y1="10.4679"
          x2="25.7368"
          y2="15.1261"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const JournalsHeadingIcon = (props) =>{
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width={34}
          height={34}
          viewBox="0 0 34 34"
          fill="none"
          {...props}
      >
        <foreignObject x={-22.552} y={-22.552} width={78.3949} height={78.3949}>
          <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                backdropFilter: "blur(11.28px)",
                clipPath: "url(#bgblur_0_8011_49280_clip_path)",
                height: "100%",
                width: "100%",
              }}
          />
        </foreignObject>
        <circle
            opacity={0.1}
            data-figma-bg-blur-radius={22.552}
            cx={16.6455}
            cy={16.6455}
            r={16.6455}
            fill="url(#paint0_linear_8011_49280)"
        />
        <path
            d="M19.5001 16.7915H13.6667C13.3251 16.7915 13.0417 16.5082 13.0417 16.1665C13.0417 15.8248 13.3251 15.5415 13.6667 15.5415H19.5001C19.8417 15.5415 20.1251 15.8248 20.1251 16.1665C20.1251 16.5082 19.8417 16.7915 19.5001 16.7915Z"
            fill="#40C9A2"
        />
        <path
            d="M17.3167 20.125H13.6667C13.3251 20.125 13.0417 19.8417 13.0417 19.5C13.0417 19.1583 13.3251 18.875 13.6667 18.875H17.3167C17.6584 18.875 17.9417 19.1583 17.9417 19.5C17.9417 19.8417 17.6584 20.125 17.3167 20.125Z"
            fill="#40C9A2"
        />
        <path
            d="M18.6667 11.6248H15.3334C14.5334 11.6248 13.0417 11.6248 13.0417 9.33317C13.0417 7.0415 14.5334 7.0415 15.3334 7.0415H18.6667C19.4667 7.0415 20.9584 7.0415 20.9584 9.33317C20.9584 10.1332 20.9584 11.6248 18.6667 11.6248ZM15.3334 8.2915C14.5084 8.2915 14.2917 8.2915 14.2917 9.33317C14.2917 10.3748 14.5084 10.3748 15.3334 10.3748H18.6667C19.7084 10.3748 19.7084 10.1582 19.7084 9.33317C19.7084 8.2915 19.4917 8.2915 18.6667 8.2915H15.3334Z"
            fill="#40C9A2"
        />
        <path
            d="M19.5 24.9582H14.5C9.81667 24.9582 8.875 22.8082 8.875 19.3332V14.3332C8.875 10.5332 10.25 8.9082 13.6333 8.7332C13.9667 8.71653 14.275 8.97486 14.2917 9.32486C14.3083 9.67486 14.0417 9.9582 13.7 9.97486C11.3333 10.1082 10.125 10.8165 10.125 14.3332V19.3332C10.125 22.4165 10.7333 23.7082 14.5 23.7082H19.5C23.2667 23.7082 23.875 22.4165 23.875 19.3332V14.3332C23.875 10.8165 22.6667 10.1082 20.3 9.97486C19.9583 9.9582 19.6917 9.6582 19.7083 9.31653C19.725 8.97486 20.025 8.7082 20.3667 8.72486C23.75 8.9082 25.125 10.5332 25.125 14.3249V19.3249C25.125 22.8082 24.1833 24.9582 19.5 24.9582Z"
            fill="#40C9A2"
        />
        <defs>
          <clipPath
              id="bgblur_0_8011_49280_clip_path"
              transform="translate(22.552 22.552)"
          >
            <circle cx={16.6455} cy={16.6455} r={16.6455} />
          </clipPath>
          <linearGradient
              id="paint0_linear_8011_49280"
              x1={0}
              y1={0}
              x2={47.4188}
              y2={52.7772}
              gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#92FDA3" />
            <stop offset={1} stopColor="#49DDDA" />
          </linearGradient>
        </defs>
      </svg>
  )
}

// export const PointIcon = () =>{
//     return(
//         <svg xmlns="http://www.w3.org/2000/svg"  width="100%" height="100%" viewBox="0 0 36 35" fill="none">
//             <path d="M18.0031 33.372C26.769 33.372 33.8752 26.2658 33.8752 17.5C33.8752 8.73408 26.769 1.62793 18.0031 1.62793C9.23725 1.62793 2.1311 8.73408 2.1311 17.5C2.1311 26.2658 9.23725 33.372 18.0031 33.372Z" fill="#F6D738"/>
//             <path d="M18.0023 30.9713C25.4429 30.9713 31.4747 24.9395 31.4747 17.4988C31.4747 10.0582 25.4429 4.02637 18.0023 4.02637C10.5616 4.02637 4.52979 10.0582 4.52979 17.4988C4.52979 24.9395 10.5616 30.9713 18.0023 30.9713Z" fill="#F3CC30"/>
//             <path d="M25.0517 6.00098C26.3915 8.09558 27.1713 10.5851 27.1713 13.2546C27.1713 20.6932 21.1424 26.7271 13.6988 26.7271C11.1143 26.7271 8.69976 25.9972 6.65015 24.7375C9.0447 28.4768 13.2339 30.9513 18.003 30.9513C25.4416 30.9513 31.4755 24.9224 31.4755 17.4838C31.4755 12.6247 28.906 8.37053 25.0517 6.00098Z" fill="#EDBD31"/>
//             <path d="M6.88947 18.7341C6.88947 12.1654 12.2135 6.84135 18.7823 6.84135C22.6215 6.84135 26.0359 8.66101 28.2105 11.4855C26.1559 7.92115 22.3066 5.5166 17.8974 5.5166C11.3286 5.5166 6.00464 10.8406 6.00464 17.4094C6.00464 20.1389 6.92447 22.6534 8.46918 24.658C7.46437 22.9134 6.88947 20.8887 6.88947 18.7341Z" fill="#F7DB5E"/>
//             <path d="M11.7079 13.997C12.3763 13.997 12.9676 14.1718 13.4818 14.5214C14.0062 14.8608 14.4124 15.3441 14.7003 15.9714C14.9985 16.5884 15.1476 17.2979 15.1476 18.1C15.1476 18.9022 15.0037 19.6066 14.7157 20.2133C14.4278 20.82 14.0216 21.2879 13.4972 21.617C12.983 21.946 12.3866 22.1106 11.7079 22.1106C11.1423 22.1106 10.6384 21.9923 10.1962 21.7558C9.75405 21.509 9.4147 21.1696 9.17819 20.7377V25.319H7.26549V16.4033C7.26549 15.5806 7.22436 14.8453 7.14209 14.1975H8.94681L9.10106 15.5395C9.30673 15.0562 9.64093 14.6808 10.1037 14.4134C10.5664 14.1358 11.1012 13.997 11.7079 13.997ZM11.1834 20.5989C11.8313 20.5989 12.33 20.383 12.6797 19.9511C13.0293 19.5192 13.2041 18.9022 13.2041 18.1C13.2041 17.2877 13.0293 16.6552 12.6797 16.2028C12.33 15.74 11.8364 15.5086 11.1989 15.5086C10.5407 15.5086 10.0368 15.7297 9.68721 16.1719C9.33758 16.6141 9.16276 17.2465 9.16276 18.0692C9.16276 18.8816 9.33758 19.5089 9.68721 19.9511C10.0368 20.383 10.5356 20.5989 11.1834 20.5989Z" fill="#976F28"/>
//             <path d="M19.2968 15.6474V19.1335C19.2968 20.0488 19.7235 20.5064 20.577 20.5064C20.8136 20.5064 21.0706 20.4652 21.3483 20.383V21.91C21.0089 22.0335 20.5976 22.0951 20.1143 22.0951C19.2299 22.0951 18.5512 21.8483 18.0782 21.3547C17.6052 20.8611 17.3686 20.1516 17.3686 19.2261V15.6474H15.8724V14.1975H17.3686V12.3002L19.2968 11.6523V14.1975H21.3637V15.6474H19.2968Z" fill="#976F28"/>
//             <path d="M25.601 22.1106C24.1922 22.1106 23.0714 21.7815 22.2384 21.1234L22.7783 19.766C23.6112 20.383 24.5624 20.6915 25.6319 20.6915C26.0947 20.6915 26.4494 20.6143 26.6962 20.4601C26.9533 20.3058 27.0818 20.0899 27.0818 19.8122C27.0818 19.5757 26.9944 19.3906 26.8196 19.2569C26.6448 19.113 26.3466 18.9896 25.925 18.8867L24.6293 18.5936C23.2102 18.2851 22.5006 17.5602 22.5006 16.4187C22.5006 15.9457 22.6343 15.5292 22.9017 15.1693C23.169 14.7991 23.5444 14.5111 24.0277 14.3055C24.511 14.0998 25.0715 13.997 25.709 13.997C26.2643 13.997 26.7991 14.0844 27.3132 14.2592C27.8274 14.4237 28.2799 14.6654 28.6706 14.9842L28.0999 16.2953C27.3184 15.7194 26.5163 15.4315 25.6936 15.4315C25.2514 15.4315 24.9069 15.5138 24.6601 15.6783C24.4133 15.8428 24.2899 16.0691 24.2899 16.357C24.2899 16.5832 24.3619 16.7632 24.5059 16.8969C24.6601 17.0306 24.9172 17.1437 25.2771 17.2362L26.6037 17.5293C27.3749 17.7041 27.9354 17.9766 28.285 18.3468C28.6449 18.7068 28.8249 19.1798 28.8249 19.766C28.8249 20.4858 28.5369 21.0565 27.9611 21.4781C27.3852 21.8998 26.5985 22.1106 25.601 22.1106Z" fill="#976F28"/>
//         </svg>
//     )
// }

export const PointIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
    >
      <path
        d="M16 32.4101C24.7868 32.4101 31.9099 25.287 31.9099 16.5002C31.9099 7.71344 24.7868 0.590332 16 0.590332C7.21319 0.590332 0.0900879 7.71344 0.0900879 16.5002C0.0900879 25.287 7.21319 32.4101 16 32.4101Z"
        fill="url(#paint0_linear_6286_21578)"
      />
      <path
        d="M15.9998 31.6563C24.3708 31.6563 31.1568 24.8703 31.1568 16.4993C31.1568 8.12832 24.3708 1.34229 15.9998 1.34229C7.62881 1.34229 0.842773 8.12832 0.842773 16.4993C0.842773 24.8703 7.62881 31.6563 15.9998 31.6563Z"
        fill="url(#paint1_linear_6286_21578)"
      />
      <path
        d="M15.9996 29.1144C22.9666 29.1144 28.6144 23.4666 28.6144 16.4996C28.6144 9.53261 22.9666 3.88477 15.9996 3.88477C9.03261 3.88477 3.38477 9.53261 3.38477 16.4996C3.38477 23.4666 9.03261 29.1144 15.9996 29.1144Z"
        fill="url(#paint2_linear_6286_21578)"
      />
      <g opacity="0.15">
        <path
          d="M15.8934 27.861C22.2945 27.861 27.4836 22.6496 27.4836 16.221C27.4836 9.79245 22.2945 4.58105 15.8934 4.58105C9.49232 4.58105 4.30322 9.79245 4.30322 16.221C4.30322 22.6496 9.49232 27.861 15.8934 27.861Z"
          fill="url(#paint3_linear_6286_21578)"
        />
      </g>
      <path
        d="M15.9998 28.4562C22.6027 28.4562 27.9555 23.1035 27.9555 16.5006C27.9555 9.89764 22.6027 4.54492 15.9998 4.54492C9.39691 4.54492 4.04419 9.89764 4.04419 16.5006C4.04419 23.1035 9.39691 28.4562 15.9998 28.4562Z"
        fill="url(#paint4_linear_6286_21578)"
      />
      <g opacity="0.12">
        <path
          d="M25.827 3.98889C25.1568 12.154 18.3151 18.5686 9.97529 18.5686C6.40961 18.5743 2.94631 17.3767 0.145752 15.1697C0.819285 7.00544 7.66265 0.590838 16.0008 0.590838C19.5652 0.585541 23.0273 1.78277 25.827 3.98889Z"
          fill="url(#paint5_linear_6286_21578)"
        />
      </g>
      <g opacity="0.05">
        <path
          d="M25.827 3.98889C25.1568 12.154 18.3151 18.5686 9.97529 18.5686C6.40961 18.5743 2.94631 17.3767 0.145752 15.1697C0.819285 7.00544 7.66265 0.590838 16.0008 0.590838C19.5652 0.585541 23.0273 1.78277 25.827 3.98889Z"
          fill="url(#paint6_linear_6286_21578)"
        />
      </g>
      <g opacity="0.15">
        <path
          d="M8.42236 7.037C10.5323 5.48769 13.0923 4.67342 15.7096 4.71911C18.3269 4.76479 20.857 5.66791 22.9116 7.28991C24.9662 8.91191 26.4319 11.1632 27.0839 13.6984C27.7359 16.2336 27.538 18.9127 26.5208 21.3247C26.5501 20.9617 26.5647 20.596 26.5647 20.2274C26.5643 18.0401 26.0465 15.8839 25.0536 13.935C24.0607 11.986 22.6209 10.2995 20.8518 9.01324C19.0826 7.72698 17.0343 6.87743 14.8742 6.53397C12.714 6.1905 10.5032 6.36288 8.42236 7.037Z"
          fill="url(#paint7_linear_6286_21578)"
        />
      </g>
      <g opacity="0.15">
        <path
          d="M15.3878 25.2318C21.003 25.2318 25.555 20.6798 25.555 15.0646C25.555 9.44945 21.003 4.89746 15.3878 4.89746C9.77269 4.89746 5.2207 9.44945 5.2207 15.0646C5.2207 20.6798 9.77269 25.2318 15.3878 25.2318Z"
          fill="url(#paint8_linear_6286_21578)"
        />
      </g>
      <path
        d="M15.4195 23.25V21.958C14.1755 21.9073 13.2138 21.5579 12.5343 20.9097C11.8548 20.2615 11.51 19.3682 11.5 18.2296H14.1691C14.1981 18.8074 14.307 19.2229 14.4961 19.4762C14.6852 19.7296 14.9754 19.8638 15.3669 19.8789L15.3744 17.3709C14.0582 17.0669 13.1073 16.65 12.5218 16.12C11.9362 15.59 11.644 14.8892 11.6451 14.0173C11.6451 13.0442 11.9946 12.2597 12.6936 11.664C13.3926 11.0682 14.3351 10.7578 15.5212 10.7328V9.75H16.6823V10.7153C17.8139 10.7462 18.6969 11.0516 19.3314 11.6316C19.9659 12.2117 20.3023 13.0212 20.3407 14.0601H17.8C17.7761 13.6135 17.6685 13.2739 17.4772 13.0416C17.2859 12.8092 17.0112 12.6875 16.6531 12.6764V14.9783C18.0516 15.3277 19.0423 15.7749 19.625 16.32C20.2078 16.8651 20.4994 17.6013 20.5 18.5284C20.5 19.6017 20.1697 20.4237 19.5091 20.9945C18.8485 21.5652 17.8553 21.8907 16.5297 21.9711V23.2483L15.4195 23.25ZM15.593 14.7162V12.6459H15.5354C15.1139 12.6459 14.7981 12.7294 14.5879 12.8966C14.3777 13.0637 14.2726 13.3173 14.2726 13.6574C14.2699 13.7789 14.2952 13.8992 14.3463 14.0082C14.3974 14.1172 14.4728 14.2117 14.5662 14.2838C14.7625 14.4433 15.1047 14.5875 15.593 14.7162ZM16.4571 19.885C16.922 19.885 17.274 19.7977 17.5131 19.623C17.7522 19.4483 17.872 19.1926 17.8726 18.856C17.8767 18.7228 17.8514 18.5904 17.7986 18.4692C17.7458 18.3479 17.6669 18.2412 17.5681 18.1571C17.3646 17.9824 16.9943 17.8165 16.4571 17.6592V19.885Z"
        fill="url(#paint9_linear_6286_21578)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6286_21578"
          x1="16"
          y1="0.590332"
          x2="16"
          y2="32.4101"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C04F" />
          <stop offset="1" stopColor="#B16F07" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6286_21578"
          x1="-5.43657"
          y1="5.88939"
          x2="34.1882"
          y2="18.6646"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6286_21578"
          x1="15.9996"
          y1="3.88477"
          x2="15.9996"
          y2="29.1144"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C04F" />
          <stop offset="1" stopColor="#B16F07" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6286_21578"
          x1="15.8934"
          y1="4.58105"
          x2="15.8934"
          y2="27.861"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C04F" />
          <stop offset="1" stopColor="#B16F07" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6286_21578"
          x1="-0.908861"
          y1="8.13161"
          x2="30.3466"
          y2="18.2085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6286_21578"
          x1="-5.17393"
          y1="3.28749"
          x2="25.3995"
          y2="17.3682"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6286_21578"
          x1="-5.17393"
          y1="3.28749"
          x2="25.3995"
          y2="17.3682"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6286_21578"
          x1="17.9416"
          y1="4.71729"
          x2="17.9416"
          y2="21.3247"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C04F" />
          <stop offset="1" stopColor="#B16F07" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6286_21578"
          x1="15.3878"
          y1="4.89746"
          x2="15.3878"
          y2="25.2318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C04F" />
          <stop offset="1" stopColor="#B16F07" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_6286_21578"
          x1="16"
          y1="9.75"
          x2="16"
          y2="23.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B16F07" />
          <stop offset="1" stopColor="#6F5E25" />
        </linearGradient>
      </defs>
    </svg>
  );
};

// export const FireIcon = () =>{
//     return(
//         <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 28 36" fill="none">
//             <g clipPath="url(#clip0_3694_15137)">
//                 <path d="M9.66799 2.86615C9.44911 2.40617 9.28088 1.92924 9.19345 1.42952C9.13254 1.07942 9.18983 0.759128 9.52629 0.543457C9.6909 0.543457 9.85551 0.543457 10.0201 0.543457C11.3069 1.0502 12.4381 1.79715 13.4993 2.6534C13.284 2.85739 13.0067 2.83108 12.7426 2.83634C11.7181 2.85563 10.6924 2.80771 9.66799 2.86615Z" fill="#FB9202"/>
//                 <path d="M15.7999 35.4062L15.777 35.4185L15.7517 35.4109C15.6631 35.4553 15.5696 35.4372 15.4767 35.4342C15.3996 35.2168 15.6136 35.2314 15.7101 35.1923C16.0502 35.0537 16.3625 34.8772 16.6351 34.6388C17.6306 33.7685 17.9176 32.5902 17.3291 31.416C16.6646 30.0904 16.1503 28.7128 15.6402 27.3299C15.5292 27.0295 15.4044 26.7349 15.2398 26.4573C14.878 25.8471 14.4384 25.7191 13.7969 26.0564C13.2596 26.3387 12.852 26.7659 12.4872 27.23C11.6726 28.2674 11.0244 29.3943 10.8628 30.7047C10.6831 32.1635 10.9653 33.516 12.1019 34.6008C12.5849 35.0619 13.1776 35.2747 13.8276 35.3816C13.9542 35.4027 14.1201 35.3471 14.1785 35.5278C13.6823 35.5342 13.1903 35.4974 12.7031 35.405C12.445 35.3466 12.1803 35.322 11.9222 35.2642C10.2435 34.9228 8.86149 34.0672 7.63503 32.942C7.06944 32.3348 6.54425 31.6983 6.12759 30.9829C5.79595 30.4095 5.55175 29.8005 5.34492 29.1757C5.21468 28.673 5.02173 28.1844 4.98676 27.6607C4.97831 27.5421 4.9759 27.4229 4.98253 27.3042C5.00786 26.7028 4.93671 26.1002 4.99821 25.4994C5.13629 24.7904 5.26051 24.0768 5.56983 23.4116C5.90509 22.712 6.30064 22.0469 6.78725 21.4338C7.21657 20.9335 7.66156 20.4466 8.12344 19.9743C8.54432 19.4886 9.046 19.0783 9.47773 18.6032C10.0234 18.1432 10.4395 17.5733 10.8977 17.0391C11.4386 16.4237 11.8902 15.7492 12.3087 15.0519C12.5005 14.8047 12.612 14.5183 12.7386 14.2377C13.0148 13.6264 13.4411 13.551 13.9325 14.0256C14.2497 14.3312 14.4788 14.7018 14.7266 15.0583C15.0492 15.6001 15.4056 16.1221 15.7216 16.668C16.099 17.3103 16.4385 17.9708 16.7207 18.6581C16.9957 19.2443 17.1645 19.8645 17.3544 20.4782C17.4919 21.0521 17.639 21.6249 17.7096 22.1889C18.3391 21.7897 18.7612 21.1538 19.1242 20.4711C19.2393 20.2993 19.3268 20.114 19.4033 19.9235C19.4841 19.7224 19.5782 19.526 19.7 19.3454C20.025 18.8656 20.4236 18.8142 20.874 19.1871C21.1001 19.3747 21.2472 19.6213 21.4113 19.8557C21.6476 20.1935 21.8725 20.5384 22.0685 20.9007C22.3736 21.4647 22.6293 22.0492 22.8584 22.646C23.0815 23.2369 23.2196 23.85 23.3619 24.4625C23.5808 25.3784 23.5066 26.31 23.5199 27.2364C23.5181 27.6496 23.4348 28.0523 23.3571 28.4562C23.2075 29.0272 23.0405 29.593 22.8029 30.1372C22.4544 30.8882 22.0172 31.5878 21.4957 32.2378C20.262 33.6756 18.7612 34.7223 16.8738 35.2022C16.6881 35.2513 16.5036 35.3074 16.3083 35.3074C16.1515 35.4015 15.9609 35.3337 15.7999 35.4062Z" fill="#FB9402"/>
//                 <path d="M14.1786 35.5274C13.7324 35.4514 13.2796 35.4023 12.8629 35.21C11.8385 34.7384 11.2572 33.9148 10.9424 32.8961C10.4022 31.1485 10.8598 29.5553 11.7938 28.0508C12.2485 27.3185 12.7767 26.6411 13.4972 26.1232C14.1304 25.6685 14.7858 25.6703 15.1512 26.1501C15.4117 26.492 15.5787 26.8825 15.7234 27.2782C16.2348 28.6809 16.769 30.0708 17.4329 31.4168C18.1727 32.9177 17.4299 34.5975 15.8247 35.2305C15.6957 35.2813 15.5715 35.3433 15.4455 35.4C15.3942 35.4719 15.2989 35.4111 15.2411 35.4637C14.8889 35.5286 14.5362 35.5654 14.1786 35.5274Z" fill="#FBE102"/>
//                 <path d="M14.6753 15.1042C14.3775 14.7582 14.167 14.3473 13.8221 14.0346C13.4079 13.6593 13.0817 13.7166 12.8399 14.2193C12.6933 14.5232 12.6204 14.8651 12.3496 15.1042C12.214 15.1486 12.0735 15.1468 11.9324 15.1468C9.10623 15.1445 6.27947 15.1427 3.45332 15.1468C3.33694 15.1468 3.21755 15.1632 3.10962 15.103C3.36166 14.4852 3.61371 13.868 3.86575 13.2502C4.14553 13.0813 4.45727 13.1666 4.75514 13.1514C4.97583 13.1403 5.19833 13.1433 5.41962 13.1544C5.56253 13.1614 5.70061 13.183 5.77719 13.3233C5.94663 13.7721 6.0015 14.2421 6.03526 14.7809C6.63462 14.3297 7.07842 13.8113 7.55537 13.3268C7.69104 13.2789 7.83153 13.2818 7.97323 13.2818C13.5068 13.2841 19.0397 13.2818 24.5732 13.2841C24.853 13.2841 25.14 13.252 25.4017 13.3911C25.711 13.8668 25.9612 14.3712 26.1644 14.8978C26.0185 15.0983 25.7948 15.072 25.588 15.0738C24.6377 15.0802 23.6868 15.0761 22.7365 15.0767C20.6243 15.0767 18.5121 15.0761 16.3998 15.0773C15.8246 15.0779 15.2494 15.0644 14.6753 15.1042Z" fill="#FC7806"/>
//                 <path d="M16.6499 18.6579C16.3207 17.9975 15.9908 17.337 15.6616 16.6766C15.6821 16.4954 15.8401 16.486 15.9709 16.4551C16.1199 16.42 16.2742 16.4294 16.4268 16.4294C19.6172 16.4288 22.8075 16.4276 25.9979 16.4311C26.265 16.4311 26.5399 16.4048 26.7896 16.5392C27 17.212 27.2056 17.8859 27.2894 18.5878C27.1688 18.6509 27.0374 18.6316 26.909 18.6316C23.759 18.6299 20.6097 18.6328 17.4597 18.6293C17.189 18.6287 16.92 18.6597 16.6499 18.6579Z" fill="#FC7107"/>
//                 <path d="M25.4006 13.3926C25.2047 13.4563 25.0075 13.3908 24.8115 13.3908C19.2195 13.3961 13.6275 13.3949 8.0355 13.3943C7.8727 13.3943 7.70507 13.4189 7.55493 13.3277C7.91069 12.849 8.26644 12.3698 8.6222 11.8911C8.71265 11.828 8.81455 11.8227 8.92309 11.8239C12.5446 11.87 16.166 11.8525 19.7875 11.8332C19.8943 11.8326 19.9986 11.8274 20.0908 11.8911C20.1602 12.2634 20.364 12.5889 20.4773 12.9671C20.5853 12.8473 20.6817 12.7403 20.7788 12.6334C20.935 12.5363 21.1105 12.5317 21.2877 12.5317C22.3436 12.5317 23.3988 12.5311 24.4546 12.5322C24.6312 12.5322 24.8079 12.5334 24.9593 12.6433C25.0684 12.9139 25.3355 13.0974 25.4006 13.3926Z" fill="#FC7B06"/>
//                 <path d="M16.6487 18.6574C16.7156 18.5136 16.8471 18.5206 16.9785 18.5206C20.3136 18.5212 23.6486 18.5212 26.9837 18.52C27.0922 18.52 27.1941 18.5329 27.2876 18.5878C27.4583 19.3769 27.5457 20.1747 27.5668 20.9801C27.4583 21.0379 27.3389 21.0251 27.2225 21.0245C25.6746 21.0221 24.1268 21.0257 22.579 21.0221C22.3824 21.0216 22.1762 21.0514 22.0055 20.914C21.7065 20.4692 21.414 20.0198 21.1077 19.5797C20.5554 18.7865 20.0579 18.8169 19.6195 19.6551C19.4724 19.9362 19.4121 20.2588 19.1902 20.5043C18.5541 20.6738 17.9186 20.682 17.283 20.5031C17.072 19.8877 16.8603 19.2728 16.6487 18.6574Z" fill="#FD6C08"/>
//                 <path d="M9.46313 10.3871C9.77126 9.65006 10.0547 8.90544 10.244 8.12984C10.3375 7.95625 10.5105 7.95684 10.6733 7.95684C13.0701 7.95041 15.4676 7.95158 17.8644 7.9545C18.0091 7.9545 18.1442 7.98197 18.2648 8.0638C18.7297 8.80725 19.1343 9.57934 19.4653 10.3871C19.3568 10.4461 19.238 10.4309 19.1216 10.4309C16.0169 10.4286 12.9116 10.4292 9.80683 10.4303C9.69046 10.4303 9.57167 10.4455 9.46313 10.3871Z" fill="#FC8305"/>
//                 <path d="M26.7881 16.5396C26.5819 16.6367 26.3763 16.5344 26.1707 16.535C22.8549 16.5414 19.5385 16.5396 16.2228 16.5385C16.0226 16.5385 15.826 16.5443 15.6614 16.6764C15.3044 16.1691 14.977 15.6436 14.6743 15.1042C14.7708 14.913 14.9535 14.9686 15.1097 14.9686C18.6093 14.9662 22.1096 14.9662 25.6093 14.9686C25.7986 14.9686 25.9826 14.9551 26.1628 14.8984C26.4336 15.4233 26.6277 15.9756 26.7881 16.5396Z" fill="#FC7507"/>
//                 <path d="M9.46348 10.3869C9.5895 10.3063 9.73181 10.3191 9.8723 10.3191C12.9342 10.3191 15.9955 10.3191 19.0575 10.3191C19.1979 10.3191 19.3402 10.308 19.4663 10.3869C19.7219 10.8703 19.9239 11.3741 20.0922 11.8913C19.7949 11.9749 19.4898 11.9597 19.1859 11.9597C16.2729 11.9597 13.3593 11.9615 10.4463 11.958C9.83853 11.9574 9.22772 12.0018 8.62354 11.8913C8.90271 11.3899 9.1831 10.8884 9.46348 10.3869Z" fill="#FC7E05"/>
//                 <path d="M3.10829 15.1029C3.23552 15.0263 3.37661 15.0339 3.51831 15.0339C6.32517 15.0345 9.13263 15.0345 11.9395 15.0339C12.0806 15.0339 12.2223 15.0269 12.3489 15.1035C11.9618 15.82 11.5096 16.4933 10.9373 17.086C8.22696 17.0246 5.51658 17.076 2.8062 17.0568C2.62289 17.0556 2.42632 17.0912 2.27075 16.9486C2.51797 16.3203 2.80499 15.7078 3.10829 15.1029Z" fill="#FC7507"/>
//                 <path d="M18.2643 8.063C15.7391 8.063 13.2132 8.063 10.6879 8.06359C10.5366 8.06359 10.381 8.03962 10.2429 8.12905C10.3563 7.49606 10.4172 6.85841 10.4389 6.21724C10.6095 6.0793 10.8151 6.10794 11.0123 6.10794C12.6205 6.1056 14.2286 6.10677 15.8367 6.10677C16.1069 6.10677 16.377 6.1132 16.6453 6.07346C16.7768 6.05417 16.9034 6.06352 17.015 6.14476C17.4895 6.74794 17.9019 7.39028 18.2643 8.063Z" fill="#FC8704"/>
//                 <path d="M2.27114 16.9492C4.98635 16.9492 7.70155 16.9492 10.4168 16.9492C10.6025 16.9492 10.7978 16.9205 10.9377 17.0865C10.5108 17.6464 10.0803 18.204 9.52616 18.6576C9.09383 18.6184 8.66089 18.6324 8.22795 18.6318C6.22305 18.6301 4.21876 18.6324 2.21386 18.6289C2.0197 18.6283 1.81107 18.6698 1.64404 18.5214C1.81107 17.9819 2.01005 17.4541 2.27114 16.9492Z" fill="#FC7007"/>
//                 <path d="M1.64274 18.5211C4.1252 18.5211 6.60766 18.5205 9.09011 18.5228C9.24568 18.5228 9.42838 18.4667 9.52486 18.6573C9.07806 19.1126 8.63065 19.5679 8.18384 20.0232C7.94024 20.0635 7.69482 20.067 7.44881 20.067C5.49818 20.0664 3.54755 20.0653 1.59752 20.0664C1.46909 20.0664 1.33824 20.0857 1.21704 20.0232C1.31472 19.5106 1.44798 19.008 1.64274 18.5211Z" fill="#FD6E08"/>
//                 <path d="M6.84826 21.463C6.40507 22.0749 6.01917 22.7208 5.65135 23.3771C5.55367 23.4262 5.44815 23.4215 5.34263 23.421C4.06914 23.4122 2.79565 23.4204 1.52156 23.4157C1.33644 23.4151 1.1441 23.435 0.985512 23.307C0.891448 22.6676 0.928229 22.0293 1.0042 21.3911C1.09706 21.2175 1.27012 21.2192 1.43292 21.2187C3.03925 21.2128 4.64619 21.2076 6.25252 21.2233C6.46838 21.2263 6.7343 21.1877 6.84826 21.463Z" fill="#FD6709"/>
//                 <path d="M17.0144 6.1441C14.8243 6.30366 12.6307 6.17625 10.4389 6.21716C10.3701 5.69289 10.3014 5.1692 10.2327 4.64493C10.3412 4.53271 10.4871 4.53855 10.6258 4.53738C12.2303 4.52336 13.8355 4.552 15.4406 4.5216C15.5238 4.51985 15.6034 4.53739 15.6794 4.57012C16.1895 5.04295 16.6375 5.56489 17.0144 6.1441Z" fill="#FB8A04"/>
//                 <path d="M15.6801 4.5699C15.4775 4.63478 15.2701 4.64764 15.0573 4.64705C13.4491 4.64355 11.8416 4.64472 10.2334 4.64472C10.0453 4.05206 9.85659 3.45882 9.66846 2.86616C9.70283 2.67738 9.85839 2.73349 9.97477 2.7329C10.7327 2.72881 11.4913 2.73115 12.2492 2.73057C12.6677 2.72998 13.0873 2.75161 13.4992 2.65283C14.2945 3.21919 15.0187 3.86094 15.6801 4.5699Z" fill="#FB8E03"/>
//                 <path d="M6.84736 21.4624C6.66345 21.3537 6.46145 21.3233 6.25041 21.3238C4.62539 21.3244 3.00097 21.3244 1.37594 21.3238C1.24691 21.3238 1.11787 21.3168 1.00391 21.3905C1.01597 20.9258 1.10219 20.4723 1.21796 20.0234C1.33193 19.9474 1.46217 19.9568 1.59121 19.9568C3.67871 19.9573 5.76622 19.9568 7.85433 19.9585C7.96648 19.9585 8.0919 19.9205 8.18476 20.0234C7.73856 20.5032 7.29296 20.9831 6.84736 21.4624Z" fill="#FD6B08"/>
//                 <path d="M22.0061 20.9151C23.724 20.9151 25.4419 20.9145 27.1597 20.9145C27.299 20.9145 27.4419 20.8976 27.5668 20.9806C27.6029 21.4826 27.6054 21.9847 27.5716 22.4867C27.4142 22.6235 27.2194 22.5931 27.0349 22.5937C26.0147 22.5972 24.9939 22.599 23.9736 22.5937C23.5757 22.5914 23.1789 22.6112 22.7821 22.6247C22.5241 22.0548 22.2654 21.485 22.0061 20.9151Z" fill="#FD6809"/>
//                 <path d="M22.7834 22.6244C22.8938 22.4689 23.0596 22.4859 23.2236 22.4859C24.6738 22.4871 26.1233 22.4865 27.5735 22.4865C27.5723 23.0826 27.5307 23.6753 27.4312 24.2639C27.2575 24.3889 27.0549 24.3691 26.8572 24.372C25.6645 24.3878 24.4706 24.3381 23.2785 24.4024C23.1133 23.8097 22.9481 23.2171 22.7834 22.6244Z" fill="#FD6509"/>
//                 <path d="M0.985352 23.307C2.3927 23.307 3.80005 23.307 5.2074 23.307C5.35935 23.307 5.51371 23.293 5.65119 23.3772C5.40759 24.047 5.24719 24.7378 5.08439 25.4287C4.95415 25.3562 4.83717 25.2592 4.67195 25.2615C3.53775 25.2767 2.40235 25.2083 1.26935 25.3018C1.07942 24.6496 0.98716 23.9844 0.985352 23.307Z" fill="#FD630A"/>
//                 <path d="M23.2773 24.4022C23.3208 24.1947 23.4932 24.2671 23.6168 24.2671C24.8879 24.2625 26.159 24.2642 27.43 24.2642C27.3511 24.7452 27.33 25.2368 27.1527 25.6997C27.0056 25.8259 26.8241 25.8037 26.6504 25.8049C25.7948 25.8084 24.9398 25.8026 24.0841 25.8078C23.6403 25.8107 23.6102 25.8481 23.5981 26.276C23.5897 26.5705 23.6301 26.8669 23.5632 27.1591C23.5366 27.2205 23.5065 27.2783 23.4221 27.2719C23.4414 26.3116 23.4239 25.3537 23.2773 24.4022Z" fill="#FD620A"/>
//                 <path d="M23.4896 27.2033C23.4896 26.8181 23.5023 26.4324 23.4854 26.0478C23.474 25.7772 23.5849 25.693 23.8556 25.6954C24.9543 25.7053 26.0535 25.6995 27.1527 25.6995C27.0496 26.219 26.8971 26.7234 26.6637 27.2033C26.5317 27.2875 26.3851 27.3126 26.2296 27.3132C25.4469 27.3138 24.6642 27.3167 23.8816 27.3108C23.7435 27.3097 23.5982 27.3149 23.4896 27.2033Z" fill="#FD5E0A"/>
//                 <path d="M1.26953 25.3022C1.29003 25.1414 1.41485 25.1531 1.53243 25.1531C2.61719 25.1531 3.70194 25.1555 4.7873 25.1514C4.99171 25.1508 5.09663 25.2244 5.08457 25.429C5.08336 26.0655 5.08155 26.7026 5.08035 27.3391C4.85242 27.2783 4.91573 27.086 4.91151 26.9445C4.90428 26.7096 4.79695 26.6225 4.5636 26.6237C3.76465 26.6272 2.9651 26.6225 2.16616 26.626C1.99552 26.6266 1.8502 26.7078 1.69041 26.7423C1.48962 26.2788 1.32923 25.8048 1.26953 25.3022Z" fill="#FD600A"/>
//                 <path d="M24.9592 12.6429C23.5658 12.6394 22.1723 12.6365 20.7788 12.633C21.0556 12.1952 21.3046 11.7434 21.5229 11.2758C21.5886 11.2191 21.667 11.1998 21.7514 11.2063C22.4551 11.2594 23.1594 11.2495 23.8636 11.2133C23.9366 11.2098 24.0017 11.2337 24.0602 11.2758C24.4304 11.6879 24.7169 12.1519 24.9592 12.6429Z" fill="#FC7C06"/>
//                 <path d="M21.4434 32.1924C21.9191 31.539 22.3689 30.8704 22.715 30.1421C22.7976 30.0048 22.911 29.9259 23.0853 29.944C23.6068 29.9972 24.1308 29.9545 24.653 29.975C24.7923 29.9802 24.9653 29.9381 25.0359 30.124C24.4607 30.9463 23.7962 31.6904 22.9924 32.3111C22.6192 32.2848 22.2453 32.3017 21.8721 32.293C21.7231 32.2895 21.5646 32.3117 21.4434 32.1924Z" fill="#FE550C"/>
//                 <path d="M5.43259 29.1852C5.64966 29.7948 5.89206 30.3945 6.20922 30.9637C6.15254 31.028 6.07536 31.0543 5.99396 31.0584C5.47419 31.0841 4.95443 31.0853 4.43466 31.0578C4.35205 31.0538 4.2815 31.0093 4.21096 30.9719C3.6936 30.4371 3.24921 29.8509 2.88501 29.208C2.89405 29.0052 3.0653 29.0221 3.19072 29.018C3.81842 28.9987 4.44612 29.0034 5.07382 29.0145C5.21853 29.0169 5.35179 29.0525 5.43259 29.1852Z" fill="#FE570B"/>
//                 <path d="M25.0366 30.124C24.4716 30.0141 23.9005 30.0983 23.3331 30.0773C23.1263 30.0697 22.899 29.9311 22.7151 30.1427C22.902 29.5957 23.0889 29.0486 23.2753 28.5009C23.3398 28.4489 23.4133 28.4109 23.4978 28.408C24.2123 28.3841 24.928 28.3759 25.6419 28.4139C25.8029 28.4226 26.0128 28.4483 25.9579 28.7067C25.7101 29.2152 25.4152 29.6956 25.0366 30.124Z" fill="#FD590B"/>
//                 <path d="M5.43363 29.185C5.26178 29.0822 5.07003 29.1201 4.88552 29.1184C4.33621 29.1149 3.7869 29.1149 3.23819 29.119C3.11578 29.1201 2.97589 29.0763 2.88605 29.2072C2.57853 28.7478 2.27825 28.2843 2.10278 27.7577C2.17996 27.5953 2.33734 27.5818 2.48809 27.5789C3.24543 27.5654 4.00276 27.569 4.7601 27.5766C4.87829 27.5777 4.99225 27.6005 5.08451 27.6818C5.11888 28.2002 5.33414 28.68 5.43363 29.185Z" fill="#FD5A0B"/>
//                 <path d="M25.9577 28.7063C25.898 28.4778 25.7032 28.5041 25.532 28.5035C24.7801 28.5 24.0275 28.5011 23.2756 28.5011C23.3245 28.0914 23.3739 27.6811 23.4234 27.2714C23.4457 27.2486 23.468 27.2264 23.4903 27.2036C24.5485 27.2036 25.6067 27.2036 26.6644 27.2036C26.4485 27.7127 26.2881 28.2469 25.9577 28.7063Z" fill="#FD5C0B"/>
//                 <path d="M5.08423 27.6809C4.23825 27.6809 3.39228 27.6821 2.5463 27.6803C2.39254 27.6803 2.24059 27.6762 2.10251 27.7575C1.92161 27.4354 1.77449 27.1005 1.69067 26.7417C1.72504 26.5534 1.87398 26.5219 2.03136 26.5213C2.94125 26.5184 3.85114 26.5236 4.76043 26.5166C4.96665 26.5149 5.01248 26.6014 5.0179 26.782C5.02333 26.9673 4.94434 27.166 5.08001 27.3384C5.08182 27.4524 5.08302 27.5669 5.08423 27.6809Z" fill="#FD5D0A"/>
//                 <path d="M21.4418 32.1931C21.8458 32.1931 22.2504 32.1943 22.6544 32.1931C22.7822 32.1931 22.9131 32.1815 22.9915 32.3112C21.9139 33.2697 20.6863 33.9974 19.338 34.5351C18.5909 34.8332 17.8312 35.0956 17.0268 35.2114C16.9557 35.2225 16.8646 35.2768 16.8628 35.1395C18.7127 34.631 20.2039 33.597 21.4418 32.1931Z" fill="#FE500C"/>
//                 <path d="M4.20996 30.9721C4.87625 30.9691 5.54254 30.9662 6.20823 30.9639C6.62187 31.6588 7.1344 32.2824 7.68552 32.878C7.46242 33.1025 7.17118 33.0241 6.90165 33.0458C6.76236 33.0569 6.6273 33.0084 6.48801 33.0241C5.63721 32.4356 4.86359 31.7663 4.20996 30.9721Z" fill="#FE530C"/>
//                 <path d="M24.0619 11.275C23.2159 11.3896 22.3699 11.3738 21.5239 11.275C21.6632 10.7507 21.7862 10.2218 21.9472 9.70335C22.0889 9.24863 22.3434 9.17499 22.6798 9.50112C23.2243 10.0283 23.6995 10.6128 24.0619 11.275Z" fill="#FC8105"/>
//                 <path d="M6.48926 33.0231C6.58332 32.9027 6.7196 32.9465 6.83898 32.9471C7.12419 32.9488 7.40819 32.9465 7.68617 32.877C8.90117 33.9869 10.2747 34.8268 11.9185 35.2043C11.936 35.2669 11.9233 35.3008 11.8473 35.2739C10.9845 35.1704 10.1686 34.901 9.36847 34.5877C8.341 34.1856 7.36478 33.69 6.48926 33.0231Z" fill="#FE500D"/>
//                 <path d="M5.77496 13.3238C5.4373 13.1858 5.08395 13.2793 4.73845 13.2601C4.44781 13.2437 4.15537 13.2525 3.86353 13.2501C3.9793 12.8831 4.07276 12.5078 4.21687 12.1519C4.4044 11.6872 4.68116 11.6393 5.02546 12.0017C5.38544 12.3804 5.64894 12.8176 5.77496 13.3238Z" fill="#FC7C07"/>
//                 <path d="M16.8627 35.1396C16.9176 35.1636 16.9718 35.1876 17.0267 35.2115C16.7921 35.3021 16.5491 35.3466 16.2971 35.3442C16.2796 35.3284 16.2736 35.3127 16.2796 35.2969C16.2856 35.2811 16.2917 35.2735 16.2977 35.2735C16.4864 35.2285 16.6746 35.1841 16.8627 35.1396Z" fill="#FE5D1E"/>
//                 <path d="M11.8467 35.2746C11.8702 35.2513 11.8943 35.2285 11.9178 35.2051C12.1681 35.312 12.4587 35.2705 12.7011 35.405C12.4074 35.4149 12.1234 35.3652 11.8467 35.2746Z" fill="#FD7413"/>
//                 <path d="M16.3 35.2744C16.2994 35.2978 16.2994 35.3218 16.2988 35.3451C16.1409 35.4264 15.9696 35.4083 15.8008 35.4071C15.9479 35.2955 16.1391 35.3381 16.3 35.2744Z" fill="#FD6F10"/>
//                 <path d="M15.2383 35.4661C15.2883 35.3912 15.3697 35.4094 15.4427 35.4023C15.5452 35.4059 15.6477 35.4088 15.7502 35.4123C15.588 35.5 15.4119 35.4748 15.2383 35.4661Z" fill="#FC8010"/>
//                 <path d="M17.2842 20.5034C17.9197 20.504 18.5559 20.504 19.1914 20.5046C18.8513 21.2258 18.3906 21.853 17.6695 22.317C17.5386 21.701 17.4114 21.1019 17.2842 20.5034Z" fill="#FD6A08"/>
//             </g>
//             <defs>
//                 <clipPath id="clip0_3694_15137">
//                     <rect width="26.6667" height="35" fill="white" transform="translate(0.929443 0.543457)"/>
//                 </clipPath>
//             </defs>
//         </svg>
//     )
// }

export const FireIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="37"
      viewBox="0 0 24 37"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.46627 12.8075C3.525 18.9173 4.67679 21.3665 7.24296 21.4349C8.36828 21.4636 9.85327 20.0713 8.78752 14.4646C6.36036 1.57853 16.9671 0.323022 16.689 0.517195C12.8828 3.16501 10.7315 8.54228 13.5249 13.7739C16.9119 20.1243 12.0929 21.3224 14.6282 22.889C17.8673 24.8903 19.659 15.1133 17.6356 10.8591C17.6356 10.8591 21.0226 14.3498 21.6074 19.48C22.1921 24.6101 19.5972 27.0439 19.3324 28.7363C19.0677 30.4287 19.4648 30.5611 19.4648 30.5611C19.4648 30.5611 20.3474 31.0906 21.7133 29.1599C23.0791 27.2292 22.7194 25.8016 22.7194 25.8016C22.7194 25.8016 23.6704 26.6997 23.4321 28.7627C22.8298 33.9789 18.4167 36.7062 12.3599 36.4171C-3.41669 35.678 -1.29402 19.374 6.46627 12.8075Z"
        fill="url(#paint0_linear_5781_21530)"
      />
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.46605 21.2018C2.14215 24.2909 1.59272 28.1258 3.00709 31.2414C4.72817 35.0344 8.70651 36.3009 12.5878 36.4819C15.379 36.6143 18.616 36.0626 20.5467 33.8517C20.6371 33.748 20.7232 33.6443 20.8048 33.5362C20.7519 33.556 20.6967 33.5715 20.6437 33.5869C20.1018 33.75 19.5192 33.7133 19.0021 33.4832C17.7334 32.9338 17.8371 31.2017 18.0136 30.0653C18.1467 29.4099 18.378 28.7783 18.6998 28.192C18.9977 27.5918 19.3066 27.0027 19.5648 26.3827C20.2571 24.7516 20.5038 22.966 20.2797 21.2084C20.2194 20.665 20.1236 20.1262 19.9928 19.5954C19.642 22.2675 18.627 25.7317 16.1248 26.173C15.3898 26.294 14.6362 26.1366 14.011 25.7317C13.2784 25.2904 12.7025 24.6638 12.5591 23.7856C12.3671 22.6073 13.0975 21.6409 13.3468 20.5398C13.6954 18.9953 13.0886 17.3955 12.3693 16.0474C10.9285 13.3422 10.5159 10.295 11.3587 7.33384C11.3742 7.28751 11.3874 7.23897 11.4007 7.19043C9.85611 9.6882 9.88038 12.8832 10.4232 15.7583C10.7873 17.6846 11.0851 20.2552 10.4011 22.1439C9.91789 23.4679 8.85655 24.5402 7.35833 24.5005C6.4716 24.4993 5.6083 24.2157 4.89367 23.6907C4.11472 23.0761 3.60326 22.1844 3.46605 21.2018Z"
          fill="url(#paint1_linear_5781_21530)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5781_21530"
          x1="-4.2228"
          y1="5.8907"
          x2="27.5364"
          y2="12.427"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5781_21530"
          x1="-1.68309"
          y1="11.5869"
          x2="24.1155"
          y2="16.8735"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.91414 5.28223C6.58791 5.28223 6.31738 5.0117 6.31738 4.68547V2.29842C6.31738 1.97219 6.58791 1.70166 6.91414 1.70166C7.24037 1.70166 7.51091 1.97219 7.51091 2.29842V4.68547C7.51091 5.0117 7.24037 5.28223 6.91414 5.28223Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M13.2789 5.28223C12.9527 5.28223 12.6821 5.0117 12.6821 4.68547V2.29842C12.6821 1.97219 12.9527 1.70166 13.2789 1.70166C13.6051 1.70166 13.8757 1.97219 13.8757 2.29842V4.68547C13.8757 5.0117 13.6051 5.28223 13.2789 5.28223Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M7.3118 12.2442C7.20836 12.2442 7.10492 12.2203 7.00944 12.1805C6.906 12.1407 6.82643 12.085 6.74686 12.0134C6.60364 11.8622 6.51611 11.6633 6.51611 11.4485C6.51611 11.3451 6.53999 11.2416 6.57977 11.1461C6.61955 11.0506 6.67525 10.9631 6.74686 10.8836C6.82643 10.812 6.906 10.7562 7.00944 10.7165C7.29588 10.5971 7.65394 10.6608 7.87673 10.8836C8.01995 11.0347 8.10748 11.2416 8.10748 11.4485C8.10748 11.4962 8.09952 11.5519 8.09156 11.6076C8.08361 11.6554 8.06769 11.7031 8.04382 11.7509C8.02791 11.7986 8.00404 11.8463 7.97221 11.8941C7.94834 11.9339 7.90856 11.9736 7.87673 12.0134C7.72555 12.1566 7.51867 12.2442 7.3118 12.2442Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M10.097 12.2443C9.99351 12.2443 9.89007 12.2204 9.79459 12.1807C9.69115 12.1409 9.61159 12.0852 9.53202 12.0135C9.3888 11.8624 9.30127 11.6634 9.30127 11.4486C9.30127 11.3452 9.32514 11.2417 9.36493 11.1462C9.40471 11.0508 9.46041 10.9633 9.53202 10.8837C9.61159 10.8121 9.69115 10.7564 9.79459 10.7166C10.081 10.5893 10.4391 10.6609 10.6619 10.8837C10.8051 11.0349 10.8926 11.2417 10.8926 11.4486C10.8926 11.4964 10.8847 11.5521 10.8767 11.6078C10.8688 11.6555 10.8528 11.7032 10.829 11.751C10.8131 11.7987 10.7892 11.8465 10.7574 11.8942C10.7335 11.934 10.6937 11.9738 10.6619 12.0135C10.5107 12.1568 10.3038 12.2443 10.097 12.2443Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M12.8811 12.2443C12.7777 12.2443 12.6743 12.2204 12.5788 12.1807C12.4753 12.1409 12.3958 12.0852 12.3162 12.0135C12.2844 11.9738 12.2525 11.934 12.2207 11.8942C12.1889 11.8465 12.165 11.7987 12.1491 11.751C12.1252 11.7032 12.1093 11.6555 12.1014 11.6078C12.0934 11.5521 12.0854 11.4964 12.0854 11.4486C12.0854 11.2417 12.173 11.0349 12.3162 10.8837C12.3958 10.8121 12.4753 10.7564 12.5788 10.7166C12.8732 10.5893 13.2233 10.6609 13.4461 10.8837C13.5893 11.0349 13.6768 11.2417 13.6768 11.4486C13.6768 11.4964 13.6689 11.5521 13.6609 11.6078C13.6529 11.6555 13.637 11.7032 13.6132 11.751C13.5972 11.7987 13.5734 11.8465 13.5415 11.8942C13.5177 11.934 13.4779 11.9738 13.4461 12.0135C13.2949 12.1568 13.088 12.2443 12.8811 12.2443Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M7.3118 15.0292C7.20836 15.0292 7.10492 15.0053 7.00944 14.9655C6.91395 14.9257 6.82643 14.87 6.74686 14.7984C6.60364 14.6472 6.51611 14.4404 6.51611 14.2335C6.51611 14.13 6.53999 14.0266 6.57977 13.9311C6.61955 13.8277 6.67525 13.7402 6.74686 13.6686C7.04126 13.3742 7.58233 13.3742 7.87673 13.6686C8.01995 13.8197 8.10748 14.0266 8.10748 14.2335C8.10748 14.4404 8.01995 14.6472 7.87673 14.7984C7.72555 14.9416 7.51867 15.0292 7.3118 15.0292Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M10.097 15.0292C9.89007 15.0292 9.6832 14.9416 9.53202 14.7984C9.3888 14.6472 9.30127 14.4404 9.30127 14.2335C9.30127 14.13 9.32514 14.0266 9.36493 13.9311C9.40471 13.8277 9.46041 13.7402 9.53202 13.6686C9.82642 13.3742 10.3675 13.3742 10.6619 13.6686C10.7335 13.7402 10.7892 13.8277 10.829 13.9311C10.8688 14.0266 10.8926 14.13 10.8926 14.2335C10.8926 14.4404 10.8051 14.6472 10.6619 14.7984C10.5107 14.9416 10.3038 15.0292 10.097 15.0292Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M12.8811 15.0291C12.6743 15.0291 12.4674 14.9416 12.3162 14.7983C12.2446 14.7267 12.1889 14.6392 12.1491 14.5358C12.1093 14.4403 12.0854 14.3368 12.0854 14.2334C12.0854 14.13 12.1093 14.0265 12.1491 13.931C12.1889 13.8276 12.2446 13.7401 12.3162 13.6685C12.4992 13.4855 12.7777 13.3979 13.0323 13.4536C13.088 13.4616 13.1358 13.4775 13.1835 13.5014C13.2312 13.5173 13.279 13.5412 13.3267 13.573C13.3665 13.5969 13.4063 13.6366 13.4461 13.6685C13.5893 13.8197 13.6768 14.0265 13.6768 14.2334C13.6768 14.4403 13.5893 14.6472 13.4461 14.7983C13.2949 14.9416 13.088 15.0291 12.8811 15.0291Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M16.8602 8.53679H3.33358C3.00735 8.53679 2.73682 8.26625 2.73682 7.94002C2.73682 7.61379 3.00735 7.34326 3.33358 7.34326H16.8602C17.1864 7.34326 17.4569 7.61379 17.4569 7.94002C17.4569 8.26625 17.1864 8.53679 16.8602 8.53679Z"
        fill="#979797"
        fillOpacity="0.35"
      />
      <path
        d="M13.2795 18.8092H6.91404C4.0098 18.8092 2.33887 17.1382 2.33887 14.234V7.47068C2.33887 4.56644 4.0098 2.89551 6.91404 2.89551H13.2795C16.1837 2.89551 17.8547 4.56644 17.8547 7.47068V14.234C17.8547 17.1382 16.1837 18.8092 13.2795 18.8092ZM6.91404 4.08903C4.63839 4.08903 3.53239 5.19503 3.53239 7.47068V14.234C3.53239 16.5096 4.63839 17.6156 6.91404 17.6156H13.2795C15.5552 17.6156 16.6612 16.5096 16.6612 14.234V7.47068C16.6612 5.19503 15.5552 4.08903 13.2795 4.08903H6.91404Z"
        fill="#979797"
        fillOpacity="0.35"
      />
    </svg>
  );
};

export const VaultIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 29 30"
      fill="none"
    >
      <path
        d="M12.9679 20.4698C12.4666 20.4698 12.0012 20.3504 11.5834 20.1117C10.6286 19.5627 10.0796 18.4408 10.0796 17.0205V13.4877C10.0796 12.0793 10.6286 10.9455 11.5834 10.3964C12.5382 9.84742 13.7795 9.93097 15.0088 10.6471L18.0762 12.4135C19.2936 13.1177 19.9978 14.156 19.9978 15.2541C19.9978 16.3521 19.2936 17.3905 18.0762 18.0947L15.0088 19.8611C14.3166 20.2669 13.6124 20.4698 12.9679 20.4698ZM12.9799 11.8287C12.7889 11.8287 12.6218 11.8645 12.4905 11.948C12.1086 12.1748 11.8818 12.7358 11.8818 13.4877V17.0205C11.8818 17.7724 12.0966 18.3334 12.4905 18.5601C12.8724 18.7869 13.4692 18.6914 14.1256 18.3095L17.193 16.5431C17.8494 16.1612 18.2194 15.6957 18.2194 15.2541C18.2194 14.8125 17.8494 14.3351 17.193 13.9651L14.1256 12.1987C13.696 11.948 13.3021 11.8287 12.9799 11.8287Z"
        fill="#D2A84E"
      />
      <path
        d="M14.4481 28.0846C7.37046 28.0846 1.61768 22.3318 1.61768 15.2542C1.61768 8.17661 7.37046 2.42383 14.4481 2.42383C21.5257 2.42383 27.2784 8.17661 27.2784 15.2542C27.2784 22.3318 21.5257 28.0846 14.4481 28.0846ZM14.4481 4.21411C8.36108 4.21411 3.40796 9.16724 3.40796 15.2542C3.40796 21.3412 8.36108 26.2943 14.4481 26.2943C20.535 26.2943 25.4882 21.3412 25.4882 15.2542C25.4882 9.16724 20.535 4.21411 14.4481 4.21411Z"
        fill="#D2A84E"
      />
    </svg>
  );
};

export const VideoCompleteIcon = () =>{
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 13 14" fill="none">
        <path d="M9.7908 5.37711C9.95197 5.19709 9.93669 4.9205 9.75667 4.75933C9.57665 4.59816 9.30006 4.61344 9.13889 4.79346L7.17354 6.98865C6.7753 7.43346 6.50711 7.73145 6.27781 7.92417C6.05938 8.10776 5.93109 8.14779 5.81901 8.14779C5.70694 8.14779 5.57864 8.10776 5.36021 7.92417C5.13091 7.73144 4.86272 7.43346 4.46448 6.98865L3.95746 6.42234C3.79629 6.24232 3.5197 6.22704 3.33969 6.38821C3.15967 6.54938 3.14439 6.82597 3.30556 7.00599L3.83423 7.59648C4.20514 8.01081 4.51452 8.35639 4.79721 8.594C5.09625 8.84534 5.4188 9.02279 5.81901 9.02279C6.21922 9.02279 6.54177 8.84534 6.84081 8.594C7.12349 8.3564 7.43286 8.01082 7.80377 7.59651L9.7908 5.37711Z" fill="#40C9A2"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M6.54818 0.564453C3.08489 0.564453 0.277344 3.372 0.277344 6.83529C0.277344 10.2986 3.08489 13.1061 6.54818 13.1061C10.0115 13.1061 12.819 10.2986 12.819 6.83529C12.819 3.372 10.0115 0.564453 6.54818 0.564453ZM1.15234 6.83529C1.15234 3.85525 3.56814 1.43945 6.54818 1.43945C9.52821 1.43945 11.944 3.85525 11.944 6.83529C11.944 9.81532 9.52821 12.2311 6.54818 12.2311C3.56814 12.2311 1.15234 9.81532 1.15234 6.83529Z" fill="#40C9A2"/>
      </svg>
  )
}

export const VideoCompleteIconBig = () =>{
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 13 14" fill="none">
        <path d="M9.7908 5.37711C9.95197 5.19709 9.93669 4.9205 9.75667 4.75933C9.57665 4.59816 9.30006 4.61344 9.13889 4.79346L7.17354 6.98865C6.7753 7.43346 6.50711 7.73145 6.27781 7.92417C6.05938 8.10776 5.93109 8.14779 5.81901 8.14779C5.70694 8.14779 5.57864 8.10776 5.36021 7.92417C5.13091 7.73144 4.86272 7.43346 4.46448 6.98865L3.95746 6.42234C3.79629 6.24232 3.5197 6.22704 3.33969 6.38821C3.15967 6.54938 3.14439 6.82597 3.30556 7.00599L3.83423 7.59648C4.20514 8.01081 4.51452 8.35639 4.79721 8.594C5.09625 8.84534 5.4188 9.02279 5.81901 9.02279C6.21922 9.02279 6.54177 8.84534 6.84081 8.594C7.12349 8.3564 7.43286 8.01082 7.80377 7.59651L9.7908 5.37711Z" fill="#40C9A2"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M6.54818 0.564453C3.08489 0.564453 0.277344 3.372 0.277344 6.83529C0.277344 10.2986 3.08489 13.1061 6.54818 13.1061C10.0115 13.1061 12.819 10.2986 12.819 6.83529C12.819 3.372 10.0115 0.564453 6.54818 0.564453ZM1.15234 6.83529C1.15234 3.85525 3.56814 1.43945 6.54818 1.43945C9.52821 1.43945 11.944 3.85525 11.944 6.83529C11.944 9.81532 9.52821 12.2311 6.54818 12.2311C3.56814 12.2311 1.15234 9.81532 1.15234 6.83529Z" fill="#40C9A2"/>
      </svg>
  )
}


export const PDFIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 44 54"
      fill="none"
    >
      <g clipPath="url(#clip0_3720_22796)">
        <path
          d="M4.456 53.6421C3.62761 53.4441 2.81714 53.2096 2.12703 52.6624C0.757051 51.5758 0.210339 50.127 0.2129 48.3929C0.224423 41.5973 0.218021 34.8016 0.218021 28.0046C0.218021 20.5497 0.220582 13.0948 0.21546 5.64119C0.21546 4.43215 0.442083 3.30127 1.18085 2.32153C2.21282 0.953537 3.60328 0.371163 5.2703 0.371163C11.4045 0.375071 17.5387 0.372466 23.6741 0.372466C26.0262 0.372466 28.3769 0.363346 30.7289 0.385494C30.9632 0.3881 31.2628 0.514476 31.419 0.687755C35.214 4.90899 38.9962 9.14196 42.7668 13.3853C42.9281 13.5677 43.0382 13.87 43.0382 14.1162C43.051 25.5761 43.0344 37.0347 43.0613 48.4946C43.0677 51.1485 41.3354 53.2708 38.9014 53.5874C38.872 53.5913 38.8451 53.6226 38.8169 53.6408H4.456V53.6421ZM26.3975 2.8088C26.2003 2.79707 26.0991 2.78665 25.998 2.78665C19.0623 2.78665 12.1266 2.78144 5.19092 2.78925C3.54054 2.79056 2.6046 3.79505 2.6046 5.51873C2.6046 19.8397 2.6046 34.1593 2.6046 48.4802C2.6046 50.273 3.55079 51.2266 5.33048 51.2266C16.202 51.2279 27.0748 51.2279 37.9463 51.2266C39.7247 51.2266 40.6683 50.2717 40.6683 48.4763C40.6683 38.2815 40.6683 28.088 40.6683 17.8932V17.3252C40.4007 17.3252 40.2138 17.3252 40.0281 17.3252C36.4329 17.3252 32.8364 17.3252 29.2411 17.3252C27.2963 17.3252 26.3987 16.4132 26.3975 14.4341C26.3962 10.7757 26.3975 7.11732 26.3975 3.46022C26.3975 3.25698 26.3975 3.05243 26.3975 2.8088ZM28.8186 2.82313V14.8654H40.635C40.4353 14.6335 40.2932 14.4641 40.1472 14.2986C36.9245 10.6559 33.6827 7.03003 30.4946 3.35599C29.9863 2.77101 29.4754 2.73584 28.8186 2.82183V2.82313Z"
          fill="white"
        />
        <path
          d="M18.1614 39.1754V29.6334C20.1293 29.4418 22.0844 29.0836 23.9256 30.1988C25.0088 30.8554 25.6464 31.8195 25.85 33.0546C26.0561 34.3015 25.9831 35.5366 25.4211 36.7065C24.5927 38.4341 23.0703 39.0543 21.3508 39.2275C20.3124 39.3318 19.2523 39.2015 18.1602 39.1754H18.1614ZM20.1754 37.4948C20.5787 37.4948 20.9193 37.5195 21.2561 37.4909C22.4647 37.384 23.352 36.6505 23.6414 35.491C23.7489 35.0597 23.7528 34.6037 23.8193 34.1608C24.0882 32.385 22.5415 30.5883 20.1767 31.2502V37.4961L20.1754 37.4948Z"
          fill="white"
        />
        <path
          d="M11.0276 29.5026C12.3182 29.5026 13.5628 29.418 14.7906 29.5287C15.8789 29.6264 16.7572 30.2114 17.1349 31.3384C17.528 32.507 17.3821 33.6236 16.5818 34.559C15.9801 35.2625 15.1427 35.5883 14.2247 35.6482C13.8355 35.6729 13.4437 35.6521 12.984 35.6521V39.0747H11.0264V29.5039L11.0276 29.5026ZM13.0532 33.9897C14.258 34.1695 14.8636 33.9571 15.2311 33.2535C15.514 32.7103 15.4526 31.9624 15.0915 31.5481C14.6779 31.0739 13.7817 30.9319 13.0545 31.2328V33.9897H13.0532Z"
          fill="white"
        />
        <path
          d="M33.0559 29.5093C33.0559 30.0174 33.0585 30.4486 33.0546 30.8799C33.0546 30.9971 33.0329 31.1157 33.0175 31.272H29.6988V33.4686H32.7794V35.221H29.6719V39.0722H27.7002V29.5093H33.0559Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3720_22796">
          <rect
            width="42.8484"
            height="53.271"
            fill="white"
            transform="translate(0.212891 0.371094)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SFilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <rect
        x="0.408203"
        y="0.18457"
        width="25.4749"
        height="25.4749"
        rx="5.30726"
        fill="#525252"
      />
      <path
        d="M20.3105 9.53886H5.98086C5.65446 9.53886 5.38379 9.26819 5.38379 8.94179C5.38379 8.6154 5.65446 8.34473 5.98086 8.34473H20.3105C20.6369 8.34473 20.9075 8.6154 20.9075 8.94179C20.9075 9.26819 20.6369 9.53886 20.3105 9.53886Z"
        fill="white"
      />
      <path
        d="M17.9226 13.5193H8.36953C8.04313 13.5193 7.77246 13.2487 7.77246 12.9223C7.77246 12.5959 8.04313 12.3252 8.36953 12.3252H17.9226C18.249 12.3252 18.5197 12.5959 18.5197 12.9223C18.5197 13.2487 18.249 13.5193 17.9226 13.5193Z"
        fill="white"
      />
      <path
        d="M14.738 17.4998H11.5536C11.2272 17.4998 10.9565 17.2291 10.9565 16.9027C10.9565 16.5763 11.2272 16.3057 11.5536 16.3057H14.738C15.0644 16.3057 15.335 16.5763 15.335 16.9027C15.335 17.2291 15.0644 17.4998 14.738 17.4998Z"
        fill="white"
      />
    </svg>
  );
};

export const CoursesVideoIcon = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0045 20.5685V10.4165L19.998 15.4925L12.0045 20.5685ZM15 0.875C6.936 0.875 0.375 7.436 0.375 15.5C0.375 23.564 6.936 30.125 15 30.125C23.064 30.125 29.625 23.564 29.625 15.5C29.625 7.436 23.064 0.875 15 0.875Z" fill="white"/>
      </svg>
  );
};

export const CoursesVideoIconBig = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="81" height="82" viewBox="0 0 61 62" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M25.4243 39.5883V22.3863L38.9688 30.9873L25.4243 39.5883ZM30.5 6.21875C16.836 6.21875 5.71875 17.336 5.71875 31C5.71875 44.664 16.836 55.7812 30.5 55.7812C44.164 55.7812 55.2812 44.664 55.2812 31C55.2812 17.336 44.164 6.21875 30.5 6.21875Z" fill="white"/>
      </svg>
  );
};
export const CompleteVideoIcon = () => {
  return (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="32" fill="#40C9A2" fillOpacity="0.2"/>
        <circle cx="32" cy="32" r="24" fill="#40C9A2" fillOpacity="0.6"/>
        <path d="M26 32L30 36L38 28" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );
};

export const RightIconGradient = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 6 11" fill="none">
        <path d="M1.8511 10.1483C1.60593 10.3913 1.21021 10.3896 0.967223 10.1444C0.724237 9.89923 0.726003 9.5035 0.971167 9.26052L2.44031 7.80443C3.03655 7.21348 3.44555 6.80678 3.7223 6.46217C3.99114 6.12743 4.08336 5.91241 4.10791 5.71985C4.12332 5.59893 4.12332 5.47659 4.10791 5.35567C4.08336 5.16311 3.99114 4.94809 3.72231 4.61335C3.44555 4.26874 3.03655 3.86204 2.44031 3.27109L0.971168 1.815C0.726004 1.57202 0.724238 1.17629 0.967224 0.931128C1.21021 0.685964 1.60593 0.684198 1.8511 0.927185L3.34671 2.40951C3.91002 2.96779 4.37041 3.42408 4.69692 3.83064C5.03644 4.25342 5.28222 4.68253 5.34788 5.19763C5.37666 5.42348 5.37666 5.65204 5.34788 5.8779C5.28222 6.39299 5.03644 6.82211 4.69692 7.24488C4.37041 7.65144 3.91002 8.10772 3.34671 8.66601L1.8511 10.1483Z" fill="url(#paint0_linear_9162_9528)"/>
        <defs>
          <linearGradient id="paint0_linear_9162_9528" x1="1.47363" y1="-1.23903" x2="7.8832" y2="8.26905" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FDFF9F"/>
            <stop offset="0.9999" stop-color="#D2A84E"/>
            <stop offset="1" stop-color="#D2A84E"/>
          </linearGradient>
        </defs>
      </svg>
  );
};



export const DropdownArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
    >
      <path
        d="M6.00001 6.19993C5.53335 6.19993 5.06668 6.01993 4.71335 5.6666L0.36668 1.31993C0.173346 1.12659 0.173346 0.806595 0.36668 0.613262C0.560013 0.419928 0.880013 0.419928 1.07335 0.613262L5.42001 4.95993C5.74001 5.27993 6.26001 5.27993 6.58001 4.95993L10.9267 0.613262C11.12 0.419928 11.44 0.419928 11.6333 0.613262C11.8267 0.806595 11.8267 1.12659 11.6333 1.31993L7.28668 5.6666C6.93335 6.01993 6.46668 6.19993 6.00001 6.19993Z"
        fill="#939393"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
    >
      <path
        d="M16.1419 20.8105C13.1043 20.8105 10.6387 18.3448 10.6387 15.3073C10.6387 12.2697 13.1043 9.80406 16.1419 9.80406C19.1795 9.80406 21.6451 12.2697 21.6451 15.3073C21.6451 18.3448 19.1795 20.8105 16.1419 20.8105ZM16.1419 11.7105C14.1592 11.7105 12.5451 13.3246 12.5451 15.3073C12.5451 17.29 14.1592 18.9041 16.1419 18.9041C18.1246 18.9041 19.7387 17.29 19.7387 15.3073C19.7387 13.3246 18.1246 11.7105 16.1419 11.7105Z"
        fill="#979797"
      />
      <path
        d="M16.1424 26.7712C11.3636 26.7712 6.85176 23.9752 3.75064 19.1201C2.40343 17.0231 2.40343 13.6042 3.75064 11.4944C6.86447 6.6394 11.3763 3.84331 16.1424 3.84331C20.9085 3.84331 25.4203 6.6394 28.5214 11.4944C29.8687 13.5915 29.8687 17.0103 28.5214 19.1201C25.4203 23.9752 20.9085 26.7712 16.1424 26.7712ZM16.1424 5.74973C12.0372 5.74973 8.11 8.21537 5.36475 12.5239C4.41153 14.0109 4.41153 16.6036 5.36475 18.0907C8.11 22.3992 12.0372 24.8648 16.1424 24.8648C20.2476 24.8648 24.1748 22.3992 26.9201 18.0907C27.8733 16.6036 27.8733 14.0109 26.9201 12.5239C24.1748 8.21537 20.2476 5.74973 16.1424 5.74973Z"
        fill="#979797"
      />
    </svg>
  );
};

export const EyeCIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="31"
      viewBox="0 0 31 29"
      fill="none"
    >
      <path
        d="M12.4741 18.4939C12.2338 18.4939 11.9935 18.4122 11.8038 18.2372C10.7668 17.2805 10.1978 16.0088 10.1978 14.6671C10.1978 11.8787 12.6511 9.61529 15.6736 9.61529C17.1279 9.61529 18.5063 10.1403 19.5433 11.097C19.7204 11.2603 19.8215 11.482 19.8215 11.7154C19.8215 11.9487 19.7204 12.1704 19.5433 12.3337L13.1443 18.2372C12.9546 18.4122 12.7144 18.4939 12.4741 18.4939ZM15.6736 11.3653C13.7008 11.3653 12.0947 12.8471 12.0947 14.6671C12.0947 15.2505 12.2591 15.8105 12.5626 16.3005L17.444 11.797C16.9129 11.517 16.3059 11.3653 15.6736 11.3653Z"
        fill="#979797"
      />
      <path
        d="M7.58005 22.2624C7.36506 22.2624 7.13743 22.1924 6.96038 22.0524C5.60724 20.9907 4.3932 19.6839 3.35621 18.1672C2.0157 16.2422 2.0157 13.1037 3.35621 11.167C6.44189 6.7102 10.9313 4.14345 15.6736 4.14345C18.4558 4.14345 21.2 5.03014 23.6028 6.69853C24.0202 6.99021 24.1087 7.53856 23.7925 7.92357C23.4764 8.30858 22.882 8.39025 22.4647 8.09857C20.3907 6.65186 18.0385 5.8935 15.6736 5.8935C11.5889 5.8935 7.68122 8.15691 4.94963 12.112C4.00116 13.4771 4.00116 15.8572 4.94963 17.2222C5.8981 18.5872 6.98568 19.7656 8.18707 20.7223C8.5791 21.0373 8.62969 21.5857 8.28824 21.959C8.11119 22.1574 7.84562 22.2624 7.58005 22.2624Z"
        fill="#979797"
      />
      <path
        d="M15.6735 25.1908C13.9916 25.1908 12.3475 24.8758 10.7668 24.2574C10.2862 24.0707 10.0586 23.5574 10.2609 23.1141C10.4633 22.6707 11.0197 22.4607 11.5002 22.6474C12.8408 23.1724 14.2445 23.4407 15.6609 23.4407C19.7456 23.4407 23.6533 21.1773 26.3849 17.2222C27.3333 15.8572 27.3333 13.4771 26.3849 12.112C25.9928 11.5404 25.5629 10.992 25.1076 10.4787C24.7788 10.1053 24.842 9.55695 25.2467 9.24194C25.6514 8.9386 26.2458 8.98527 26.5872 9.37028C27.0804 9.9303 27.561 10.537 27.9909 11.167C29.3314 13.0921 29.3314 16.2305 27.9909 18.1672C24.9053 22.624 20.4158 25.1908 15.6735 25.1908Z"
        fill="#979797"
      />
      <path
        d="M16.5459 19.6489C16.1032 19.6489 15.6986 19.3573 15.61 18.9373C15.5089 18.4589 15.8503 18.0039 16.3688 17.9222C17.7599 17.6889 18.9234 16.6155 19.1763 15.3321C19.2775 14.8538 19.7707 14.5504 20.2892 14.6321C20.8076 14.7255 21.1491 15.1805 21.0479 15.6588C20.6432 17.6772 18.8981 19.2756 16.7229 19.6489C16.6597 19.6373 16.6091 19.6489 16.5459 19.6489Z"
        fill="#979797"
      />
      <path
        d="M3.02734 27.2092C2.78706 27.2092 2.54678 27.1275 2.35709 26.9525C1.99035 26.6142 1.99035 26.0541 2.35709 25.7158L11.8038 17.0005C12.1706 16.6622 12.7776 16.6622 13.1443 17.0005C13.5111 17.3389 13.5111 17.8989 13.1443 18.2372L3.69759 26.9525C3.50789 27.1275 3.26762 27.2092 3.02734 27.2092Z"
        fill="#979797"
      />
      <path
        d="M18.873 12.5904C18.6328 12.5904 18.3925 12.5087 18.2028 12.3337C17.836 11.9954 17.836 11.4354 18.2028 11.097L27.6495 2.38173C28.0163 2.04339 28.6233 2.04339 28.99 2.38173C29.3568 2.72007 29.3568 3.28009 28.99 3.61844L19.5433 12.3337C19.3536 12.5087 19.1133 12.5904 18.873 12.5904Z"
        fill="#979797"
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
    >
      <path
        d="M19.0645 25.3173L10.7779 17.0307C9.79929 16.0521 9.79929 14.4507 10.7779 13.4721L19.0645 5.18547"
        stroke="white"
        strokeWidth="1.90642"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DropDownCheck = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M15.4321 6.11012C15.631 5.87146 15.5988 5.51677 15.3601 5.31789C15.1215 5.11901 14.7668 5.15125 14.5679 5.38991L10.5249 10.2415C9.71276 11.2161 9.14145 11.8995 8.64593 12.347C8.16196 12.784 7.82796 12.9229 7.50001 12.9229C7.17207 12.9229 6.83807 12.784 6.3541 12.347C5.85857 11.8995 5.28727 11.2161 4.47514 10.2415L3.43214 8.98991C3.23326 8.75125 2.87857 8.71901 2.63991 8.91789C2.40125 9.11677 2.36901 9.47146 2.56789 9.71012L3.63984 10.9965C4.41629 11.9282 5.03811 12.6744 5.60013 13.1819C6.18067 13.7062 6.77412 14.0479 7.50001 14.0479C8.22591 14.0479 8.81936 13.7062 9.3999 13.1819C9.96191 12.6744 10.5837 11.9282 11.3602 10.9965L15.4321 6.11012Z"
        fill="#40C9A2"
      />
    </svg>
  );
};

export const CheckboxEmpty = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 18 19"
      fill="none"
    >
      <circle
        cx="8.76288"
        cy="9.3212"
        r="8.04777"
        transform="rotate(0.0359661 8.76288 9.3212)"
        stroke="#979797"
        strokeOpacity="0.35"
        strokeWidth="1.36403"
      />
    </svg>
  );
};

export const CheckboxFill = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 19 19"
      fill="none"
    >
      <circle
        cx="9.67562"
        cy="9.32097"
        r="8.81544"
        transform="rotate(0.0359661 9.67562 9.32097)"
        fill="#212121"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8103 6.26175C13.9799 6.41452 13.9935 6.67581 13.8407 6.84534L9.57457 11.5795C9.03726 12.1758 8.12819 12.2495 7.50175 11.7477L5.55979 10.1922C5.38167 10.0495 5.35294 9.78944 5.49562 9.61132C5.6383 9.43321 5.89835 9.40448 6.07647 9.54715L8.01843 11.1027C8.30318 11.3308 8.71639 11.2973 8.96062 11.0262L13.2267 6.29209C13.3795 6.12256 13.6408 6.10897 13.8103 6.26175Z"
        fill="url(#paint0_linear_5824_3103)"
        stroke="url(#paint1_linear_5824_3103)"
        strokeWidth="0.918275"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5824_3103"
          x1="3.63767"
          y1="7.03849"
          x2="13.7714"
          y2="11.7529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5824_3103"
          x1="3.63767"
          y1="7.03849"
          x2="13.7714"
          y2="11.7529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PenIconSession = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#979797"
        fillRule="evenodd"
        d="m14.023 4.723.09.052c.778.45 1.427.824 1.902 1.19.501.387.9.832 1.066 1.454s.044 1.206-.197 1.792c-.228.555-.602 1.204-1.052 1.982l-3.875 6.712c-.297.516-.532.923-.89 1.23-.357.307-.795.478-1.349.694l-.15.058c-1.028.402-1.875.733-2.57.895-.725.17-1.426.191-2.08-.186-.653-.377-.985-.995-1.201-1.708-.207-.682-.344-1.582-.51-2.673l-.024-.16c-.09-.587-.161-1.052-.074-1.515q.015-.087.04-.171c.107-.395.32-.763.58-1.214l3.876-6.712c.45-.779.824-1.427 1.19-1.903.388-.501.832-.899 1.454-1.066.622-.166 1.206-.044 1.792.197.555.228 1.204.603 1.982 1.052m-5.52 3.164 5.63 3.25-3.424 5.93c-.373.646-.48.81-.619.93s-.318.2-1.013.472c-1.097.428-1.843.718-2.42.853-.557.13-.81.078-.989-.025s-.35-.297-.515-.844c-.172-.567-.294-1.358-.472-2.522-.112-.737-.132-.933-.098-1.113s.124-.355.497-1.001zm6.994.753c-.133.323-.335.702-.616 1.197L9.255 6.59c.288-.491.515-.856.728-1.132.284-.369.476-.486.654-.534s.403-.042.833.135c.451.186 1.013.508 1.848.99s1.395.807 1.78 1.105c.369.284.486.476.534.654s.042.403-.135.833"
        clipRule="evenodd"
      ></path>
      <path
        fill="#979797"
        d="M12.66 20.251a.75.75 0 0 1 .75-.75h6a.75.75 0 1 1 0 1.5h-6a.75.75 0 0 1-.75-.75"
      ></path>
    </svg>
  );
};
